/*
*/

import React from 'react';
import { useState, useEffect } from 'react';

import { 
  ActivityIndicator, 
  CheckBox, 
  Image, 
  ImageBackground,
  Text, 
  TextInput, 
  TouchableOpacity, 
  View, 
//  Picker, 
  ScrollView, 
  StyleSheet,
} from 'react-native'; // react-native-web の場合は iOS で error が発生
import Icon from 'react-native-vector-icons/FontAwesome';
import StepIndicator from 'react-native-step-indicator';
import { Video } from 'expo-av'; // for expo
//import { Video } from 'react-native-unimodules'; // for react-native
import { RadioButton } from 'react-native-paper';
//import { Calendar } from 'react-native-calendars';
import QRCode from 'react-native-qrcode-svg';
//import Ticker, { Tick } from "react-native-ticker";

import RNDropzone from 'react-dropzone'; // only for web ?

import { bf } from './bf';
import { ic } from './ic';
import { cf } from './cf';

import { iv } from './iv';

export class ce { // common element 

  static _elm(pd_defs, p_idx='-1') {
    //
    if (false) {
    }
    else if (pd_defs.type == 'Avt'){
      return (
        <ce.Avt
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          uri={pd_defs.uri}
          name={pd_defs.name}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'Btn'){
      return (
        <ce.Btn
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_rvs={pd_defs.b_rvs}
          pfx={pd_defs.pfx}
          stlCta={pd_defs.stlCta}
          stlBtn={pd_defs.stlBtn}
          stlPfx={pd_defs.stlPfx}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'Btns'){
      return (
        <ce.Btns
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          ld_defss={pd_defs.ld_defss}
          stlCta={pd_defs.stlCta}
        />
      );
    }
    else if (pd_defs.type == 'Chb'){
      return (
        <ce.Chb
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          onChg={pd_defs.onChg}
        />
      );
    }
    else if (pd_defs.type == 'Clds'){
      return (
        <ce.Clds
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          b_dlt={pd_defs.b_dlt}
          b_newLine={pd_defs.b_newLine}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          dd_defss={pd_defs.dd_defss}
          b_row={pd_defs.b_row}
          b_ttl={pd_defs.b_ttl}
          do_stlRows={pd_defs.do_stlRows}
          b_withNo={pd_defs.b_withNo}
          b_spr={pd_defs.b_spr}
          stlCta={pd_defs.stlCta}
          b_wotData={pd_defs.b_wotData}
          ld_sortss={pd_defs.ld_sortss}
          prtFld={pd_defs.prtFld}
          prtKey={pd_defs.prtKey}
          prtNmb={pd_defs.prtNmb}
          d_prts={pd_defs.d_prts}
          ob_newLine={pd_defs.ob_newLine}
          ob_ftr={pd_defs.ob_ftr}
          b_oneTtl={pd_defs.b_oneTtl}
          d_insDats={pd_defs.d_insDats}
          b_plcNewAtTop={pd_defs.b_plcNewAtTop}
          stlLbl={pd_defs.stlLbl}
          o_pfx={pd_defs.o_pfx}
          b_hdr={pd_defs.b_hdr}
        />
      );
//          d_pnts={pd_defs.d_pnts}
    }
    else if (pd_defs.type == 'Files'){
      return (
        <ce.Files
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          n_pntW={pd_defs.n_pntW}
        />
      );
    }
    else if (pd_defs.type == 'Img'){
      return (
        <ce.Img
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          uri={pd_defs.uri}
          msg={pd_defs.msg}
          stlCta={pd_defs.stlCta}
          stlImg={pd_defs.stlImg}
        />
      );
    }
    else if (pd_defs.type == 'Imgs'){
      return (
        <ce.Imgs
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          pfx={pd_defs.pfx}
          msg={pd_defs.msg}
          stlCta={pd_defs.stlCta}
          stlImg={pd_defs.stlImg}
          ld_defss={pd_defs.ld_imgss}
        />
      );
    }
    else if (pd_defs.type == 'Inp'){
      return (
        <ce.Inp
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          d_ids={pd_defs.d_ids}
          ctlVal={pd_defs.ctlVal}
          ini={pd_defs.ini}
          pfx={pd_defs.pfx}
          b_mln={pd_defs.b_mln}
          phd={pd_defs.phd}
          onBlur={pd_defs.onBlur}
          onChg={pd_defs.onChg}
          onFcs={pd_defs.onFcs}
          onPrs={pd_defs.onPrs}
          stlCta={pd_defs.stlCta}
          stlInp={pd_defs.stlInp}
          n_lyr={pd_defs.n_lyr}
          d_btnDefs={pd_defs.d_btnDefs}
          n_pntW={pd_defs.n_pntW}
          n_col={pd_defs.n_col}
          o_stlVal={pd_defs.o_stlVal}
          kbdType={pd_defs.kbdType}
          stlLbl={pd_defs.stlLbl}
          onFcsAsCld={pd_defs.onFcsAsCld}
          onChgAsCld={pd_defs.onChgAsCld}
          onBlurAsCld={pd_defs.onBlurAsCld}
        />
      );
/*
          s_pnts={pd_defs.d_pnts}
          b_cmm={pd_defs.b_cmm}
          b_row={pd_defs.b_row}
 */
    }
    else if (pd_defs.type == 'InpTree') {
      return (
        <ce.InpTree
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
        />
      );
    }
    else if (pd_defs.type == 'InpTree2') {
      return (
        <ce.InpTree2
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
          d_elmDefss={pd_defs.d_elmDefss}
        />
      );
    }
    else if (pd_defs.type == 'Lbl'){
      return (
        <ce.Lbl
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_btnVsb={pd_defs.b_btnVsb}
          pfx={pd_defs.pfx}
          iconName={pd_defs.iconName}
          onBtnPrs={pd_defs.onBtnPrs}
          stlCta={pd_defs.stlCta}
          stlPfx={pd_defs.stlPfx}
          stlBtn={pd_defs.stlBtn}
          n_col={pd_defs.n_col}
        />
      );
    }
    else if (pd_defs.type == 'List'){
      return (
        <ce.List
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          state={pd_defs.state}
          ld_itemss={pd_defs.ld_itemss}
          pfx={pd_defs.pfx}
          b_chb={false}
          b_prs={pd_defs.b_prs}
          onPrs={(_d_items, _key) => {
/*
            new Promise( _o_end1 => {
              if (bf.f(pd_defs.keyName) && bf.f(_d_items.key)) {
                cf.myRN_setCmns({
                  [pd_defs.keyName]: _d_items.key,
                })
                .then(() => {
                  _o_end1();
                });
              }
              else {
                _o_end1();
              };
            })
            .then( () => new Promise( _o_end1 => {
              if (bf.f(pd_defs.pfxName) && bf.f(_d_items.pfx)) {
                cf.myRN_setCmns({
                  [pd_defs.pfxName]: _d_items.pfx,
                })
                .then(() => {
                  _o_end1();
                });
              }
              else {
                _o_end1();
              };
            }))
            .then(() => {
              if (bf.f(pd_defs.nextPage)) {
                let _d_pageInfs = {
                  sgc_pageRole: pd_defs.nextRole,
                  sgc_pageName: pd_defs.nextPage,
                  sgc_pageMode: pd_defs.nextMode,
                };
                cf.myRN_move_fwd(_d_pageInfs);
              };
            });
*/
            cf.myRN_setCmns({
              [pd_defs.keyName]: _d_items.key,
              [pd_defs.pfxName]: _d_items.pfx,
            })
            .then(() => {
              if (bf.f(pd_defs.nextPage)) {
                let _d_pageInfs = {
                  sgc_pageRole: pd_defs.nextRole,
                  sgc_pageName: pd_defs.nextPage,
                  sgc_pageMode: pd_defs.nextMode,
                };
                cf.myRN_move_fwd(_d_pageInfs);
              };
            });
          }}
          dtmFld={pd_defs.dtmFld}
          sumFld={pd_defs.sumFld}
        />
      );
    }
    else if (pd_defs.type == 'ListBean'){
      return (
        <ce.ListBean
          key={p_idx}
          state={pd_defs.state}
          stlCta={pd_defs.stlCta}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'ListCard'){
      return (
        <ce.ListCard
          key={p_idx}
          n_col={pd_defs.n_col}
          b_vsb={pd_defs.b_vsb}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          b_chb={false}
          b_bdr={pd_defs.b_bdr} // 枠線の表示
          b_img={pd_defs.b_img} // 画像の表示
          b_menu={pd_defs.b_menu} // メニューの表示
          onPrs={(_d_items) => {
            //
            if (bf.f(pd_defs.nextPage)) { // 画面遷移は nextPage の有無により決定
              let _d_pageInfs = {
                sgc_pageName: pd_defs.nextPage,
                sgc_pageMode: 'show',
              };
              cf.myRN_move_fwd(_d_pageInfs);
            };
          }} 
        />
      );
    }
    else if (pd_defs.type == 'ListChat'){
      return (
        <ce.ListChat
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          b_chb={false}
          b_prs={pd_defs.b_prs}
          b_avt={pd_defs.b_avt}
          onPrs={(_d_items) => {
            //
            let _d_pageInfs = {
              sgc_pageName: pd_defs.nextPage,
              sgc_pageMode: 'show',
            };
            cf.myRN_move_fwd(_d_pageInfs);
          }} 
        />
      );
    }
    else if (pd_defs.type == 'ListEnt') {
      return (
        <ce.ListEnt
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          stlHdr={pd_defs.stlHdr}
        />
      );
    }
    else if (pd_defs.type == 'Msg'){
      return (
        <ce.Msg
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          pfx={pd_defs.pfx}
          stlCta={pd_defs.stlCta}
        />
      );
    }
    else if (pd_defs.type == 'Mp4'){
      return (
        <ce.Mp4
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          pfx={pd_defs.pfx}
          uri={pd_defs.uri}
          msg={pd_defs.msg}
          onPrs={pd_defs.onPrs}
        />
      );
    }
    else if (pd_defs.type == 'Pck'){
/*
          onChg={(_key, _d_items)=>{
            if (pd_defs.onChg){
              pd_defs.onChg(_key, _d_items);
            };
          }}
          onBlur={(_key, _d_items)=>{
            if (pd_defs.onBlur){
              pd_defs.onBlur(_key, _d_items);
            };
          }}
*/
      return (
        <ce.Pck
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          d_ids={pd_defs.d_ids}
          ctlVal={pd_defs.ctlVal}
          ini={pd_defs.ini}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
          phdCcd={pd_defs.phdCcd}
          ld_itemss={pd_defs.ld_itemss}
          onDltPrs={pd_defs.onDltPrs}
          onChg={pd_defs.onChg}
          onBlur={pd_defs.onBlur}
          stlCta={pd_defs.stlCta}
          stlPfx={pd_defs.stlPfx}
          n_col={pd_defs.n_col}
          stlLbl={pd_defs.stlLbl}
          o_rlcFldPrs={pd_defs.o_rlcFldPrs}
          onChgAsCld={pd_defs.onChgAsCld}
          onDltPrsAsCld={pd_defs.onDltPrsAsCld}
          prtKey={pd_defs.prtKey}
          b_newLine={pd_defs.b_newLine}
        />
      );
//          d_pnts={pd_defs.d_pnts}
    }                
    else if (pd_defs.type == 'PckDate'){
        return (
            <ce.PckDate
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                b_edt={pd_defs.b_edt}
                state={pd_defs.state}
                pfx={pd_defs.pfx}
                onChg={(_d_items)=>{
                    if (pd_defs.onChg){
                        pd_defs.onChg(_d_items);
                    };
                }}
            />
        );
    }
    else if (pd_defs.type == 'PckSch') {
        return (
            <ce.PckSch
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                b_edt={pd_defs.b_edt}
                state={pd_defs.state}
                pfx={pd_defs.pfx}
            />
        );
    }
    else if (pd_defs.type == 'PckSchs') {
        return (
            <ce.PckSchs
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                b_edt={pd_defs.b_edt}
                state={pd_defs.state}
                pfx={pd_defs.pfx}
            />
        );
    }
    else if (pd_defs.type == 'PckSlc'){
      return (
        <ce.PckSlc
          key={p_idx}
          b_vsb={pd_defs.b_vsb}
          b_edt={pd_defs.b_edt}
          state={pd_defs.state}
          d_ids={pd_defs.d_ids}
          ctlVal={pd_defs.ctlVal}
          ini={pd_defs.ini}
          pfx={pd_defs.pfx}
          phd={pd_defs.phd}
          phdCcd={pd_defs.phdCcd}
          ld_itemss={pd_defs.ld_itemss}
          onDltPrs={pd_defs.onDltPrs}
          onChg={pd_defs.onChg}
          onBlur={(_key, _d_items)=>{
            if (pd_defs.onBlur){
              pd_defs.onBlur(_key, _d_items);
            };
          }}
          stlCta={pd_defs.stlCta}
          stlPfx={pd_defs.stlPfx}
          n_col={pd_defs.n_col}
          stlLbl={pd_defs.stlLbl}
          onChgAsCld={pd_defs.onChgAsCld}
        />
      );
    }                
    else if (pd_defs.type == 'Qr'){
        return (
            <ce.Qr
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                pfx={pd_defs.pfx}
                val={pd_defs.val}
            />
        );
    }
    else if (pd_defs.type == 'Rfr'){
        return (
            <ce.Rfr
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                b_edt={pd_defs.b_edt}
                state={pd_defs.state}
                pfx={pd_defs.pfx}
                onChgStr={pd_defs.onChgStr}
                onChgKey={pd_defs.onChgKey}
            />
        );
    }
    else if (pd_defs.type == 'Spr'){
        return (
            <ce.Spr
                key={p_idx}
            />
        );
    }
    else if (pd_defs.type == 'Tck'){
        return (
            <ce.Tck
                key={p_idx}
                b_vsb={pd_defs.b_vsb}
                n_cnt={pd_defs.n_cnt}
                n_val={pd_defs.n_val}
                stlCta={pd_defs.stlCta}
                stlPfx={pd_defs.stlPfx}
            />
        );
    };
    //
    return (
      <Text>incorrect def</Text>
    );
  }

    static _elms(pld_defss) {
        //
        return pld_defss?.map((_d_defs, _idx) => {
            //
            return ce._elm(_d_defs, _idx);
        });
    }

    static Avt (pd) { // avator
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <View
                        style={ [{
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }, pd.stlCta] }
                    >
                        { (pd.pfx) ?
                            <Text 
                                style={ [{
                                    fontSize: ic.gn_fontSizeSml,
                                    color: ic.g_fontCcdSml,
                                    paddingTop: ic.gn_mgnNrm,
                                    paddingBottom: ic.gn_mgnNrm,
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    fontWeight: 'bold',
                                }, pd.stlPfx] }
                            >
                                { pd.pfx }
                            </Text>
                        : null }
                        <TouchableOpacity
                            onPress={pd.onPrs}
                        >
                            <View
                                style={{
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <ce.Img
                                    uri={pd.uri}
                                    msg={pd.name.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                                    stlCta={{
                                        width: ic.gn_iconSizeLrg * 2.5,
                                        height: ic.gn_iconSizeLrg * 2.5,
                                        margin: ic.gn_mgnNrm,
                                    }}
                                    stlImg={{
                                        width: ic.gn_iconSizeLrg * 2.5,
                                        height: ic.gn_iconSizeLrg * 2.5,
                                    }}
                                />
                                <Text
                                    style={{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                    }}
                                >
                                    {pd.name}
                                </Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                : null }
            </View>
        );
    }

    static Bdy (pd) {
        //
        const [_so_scrView, _setScrView] = useState(null);
        const [_sn_oldScrH, _setOldScrH] = useState(0);
        const [_sn_cttSizeChgCnt, _setCttSizeChgCnt] = useState(0); // content size change count : １回目までが初回ロード
        const [_sn_crrScrY, _setCrrScrY] = useState(0);

        useEffect(() => {
          if (global.c?.state.sgcb_srlToEnd == true) {
            _so_scrView.scrollToEnd({
              animated: true,
            });
            global.c?.setState({
              sgcb_srlToEnd: false,
            });
          };
        }, [
          global.c?.state.sgcb_srlToEnd
        ]);

        return (
            <View
              style={[{
                position: 'absolute',
                zIndex: ic.gn_zIdxBdy,
                top: (global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY,
                left: ((pd.n_bdyW) ? (ic.gn_w - pd.n_bdyW) / 2 : 0),
                width: ((pd.n_bdyW) ? pd.n_bdyW : ic.gn_w),
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'stretch',
                borderWidth: 0,
                margin: 0,
                padding: 0,
                backgroundColor: ic.g_ccdWN,
              }, pd.stlCta]}
              ref={(_o) => {
              }}
            >
                <ScrollView
                    contentContainerStyle={[{
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        borderWidth: 0,
                        margin: 0,
                        padding: 0,
                    }]}
                    showsVerticalScrollIndicator={true}
                    ref={(_o) => {
                        _setScrView(_o);
                    }}
                    onContentSizeChange={async (_w, _h)=> {
                        await _setCttSizeChgCnt(_sn_cttSizeChgCnt+1);
                        //
                        if (pd.b_ste == true && _so_scrView) { // 最下行を常に表示（スクロールしている場合をのぞく）

                            if (_sn_cttSizeChgCnt >= 2 && _sn_crrScrY == 0) { // データロード後でスクロールが先頭にあるサイズ変更の場合
                                let _dffH = _h - _sn_oldScrH;
                                _so_scrView.scrollTo({
                                    y: _dffH, 
                                    animated: false
                                });
                            };
                            if (_sn_cttSizeChgCnt < 2 || _sn_cttSizeChgCnt >= 2 && _sn_crrScrY != 0) { // データロード前か、データロード後でスクロールが先頭にないサイズ変更の場合（＝データ追加のあった場合）
                                _so_scrView.scrollToEnd({
                                    animated: false
                                });
                            };
                            _setOldScrH(_h)
                        };
                    }}
                    scrollEventThrottle={ic.gn_bdyH}
                    onScroll={async (_e)=>{
                        //
                        _setCrrScrY(_e.nativeEvent.contentOffset.y);
                        //
                        if (pd.onScrTop){ // for infinit scroll
                            if (_e.nativeEvent.contentOffset.y == 0){
                                pd.onScrTop();
                            };
                        };
                        if (pd.onScrBtm){ // for infinit scroll
                            if ((_e.nativeEvent.contentSize.height-_e.nativeEvent.contentOffset.y)<=_e.nativeEvent.layoutMeasurement.height){
                                pd.onScrBtm();
                            };
                        };
                    }}
                >
                    <View
                        style={{
                            width: ((pd.n_bdyW) ? pd.n_bdyW : ic.gn_w) - ic.gn_scbW,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'stretch',
                            borderWidth: 0,
                            margin: 'auto',
                            padding: 0,
                        }}
                    >
                        { pd.children }
                    </View>
                </ScrollView>
            </View>
        );
    }

/*
    static Top (pd) {
        return (
            <>
                { (pd.b_vsb) ?
                    <View
                        style={{
                            position: 'absolute',
                            zIndex: ic.gn_zIdxBdy,
                            top: ic.gn_hdrH,
                            left: 0,

                            height: pd.n_h,
                            width: ic.gn_w,

                            backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        }}
                    >                
                        { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
                    </View>
                : null }
            </>
        );
    };
*/

  static Btm (pd) {
    return (
      <View
        style={{
          position: 'absolute',
          zIndex: ic.gn_zIdxBdy,
          top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
          left: (ic.gn_w - ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW)) / 2,
          height: (pd.n_h) ? pd.n_h : 0,
          width: (pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW,
          justifyContent: 'center',
        }}
      >                
        { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
      </View>
    );
  };

static Btn (pd) {
  return (
    <>
      { (pd.b_vsb != false) ?
        <View 
          style={[{
            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
            width: ic.gn_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginStart: 'auto',
            marginEnd: 'auto',
            marginTop: 0,
            marginBottom: 0,
            paddingStart: 0,
            paddingEnd: 0,
            paddingTop: 0,
            paddingBottom: 0,
          }, pd.stlCta]}
        >
          <TouchableOpacity
            onPress={()=>{
              if (pd.onPrs) {
                pd.onPrs();
              };
            }}
          >
            <View
              style={ [{ 
                height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
                lineHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
                width: ic.gn_btnWNrm, 
                backgroundColor: (pd.b_rvs) ? ic.g_ccdWN : (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                borderWidth: ic.gn_bdrWNrw,
                borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                borderRadius: ic.gn_bdrRdsNrm,
                marginStart: 0,
                marginEnd: 0,
                marginTop: 0,
                marginBottom: 0,
                paddingStart: 0,
                paddingEnd: 0,
                paddingTop: 0,
                paddingBottom: 0,
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'center', 
                alignItems: 'center',
              }, pd.stlBtn]}
            >
              <Text
                style={[{ 
                  fontSize: ic.gn_fontSizeNrm,
                  color: (pd.b_rvs) ? (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd : ic.g_ccdWN,
                }, pd.stlPfx]}
                numberOfLines={1}
              >
                { pd.pfx }
              </Text>
            </View>
          </TouchableOpacity>
        </View>
      : null}
    </>
  );
}

  static BtnIcon (pd) {
    if (pd.b_vsb == false) {
      return null;
    };

    return (
      <View
        key={-1}
        style={[{
          height: ic.gn_btnIconSize,
          width: ic.gn_btnIconSize,
          marginTop: 0,
          marginBottom: 0,
          marginLeft: 0,
          marginRight: 0,
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0,
        }, pd.stlCta]}
      >
        <TouchableOpacity
          key={-1}
          onPress={pd.onPrs}
        >
          <View
            key={-1}
            style={[{
              height: ic.gn_btnIconSize,
              width: ic.gn_btnIconSize,
              marginTop: 0,
              marginBottom: 0,
//                marginTop: 'auto',
//                marginBottom: 'auto',
              marginLeft: 0,
              marginRight: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
              backgroundColor: '#dddddd',
              borderColor: '#dddddd',
              borderRadius: ic.gn_btnIconSize/2,
            }, pd.stlBtn]}
          >
            <Icon
              key={-1}
              name={pd.iconName}
              type="FontAwesome"
              underlayColor="transparent"
              size={ic.gn_btnIconSize - ic.gn_mgnNrm * 2}
              style={[{
                color: '#555555',
                marginTop: 'auto',
                marginBottom: 'auto',
                marginLeft: 'auto',
                marginRight: 'auto',
              }, pd.stlIcon]}
            />
          </View>
        </TouchableOpacity>
      </View>
    );
  }
//              color={(pd.ccd) ? pd.ccd : '#555555'}
//              color={'#dddddd'}

    static BtnIconPfx(pd){
        return (
            <TouchableOpacity
                onPress={pd.onPrs}
            >
                <View
                    style={{
                        height: ic.gn_iconSizeSml*1.2 + ic.gn_fontSizeSml * 0.3,
                        width: ic.gn_btnWSml, // 全角5文字まで
                        marginLeft: 0,
                        marginRight: 0,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Icon
                        name={pd.iconName}
                        size={ic.gn_iconSizeSml*1.2}
                        color={ic.g_backCcd}
                    />
                    <Text
                        style={{
                            fontSize: ic.gn_fontSizeSml*0.7,
                            color: ic.g_backCcd,
                            margin: 'auto',
                        }}
                    >
                        {pd.pfx}
                    </Text>
                    { (bf.f(pd.n_cnt) && pd.n_cnt > 0) ?
                        <View
                            style={{
                                position: 'absolute',
                                top: -4,
                                right: -4,
                                height: 12,
                                width: 36,
                                backgroundColor: '#ff0000',
                                borderRadius: 6,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: 10,
                                    fontWeight: 'bold',
                                    color: '#ffffff',
                                    textAlign: 'center',
                                }}
                            >
                                {pd.n_cnt}
                            </Text>
                        </View>
                    : null }
                </View>
            </TouchableOpacity>
        );
    }

    static Btns (pd) {
        //
        let _r = [];
        //
        for (let [_idx, _d_defs] of bf.e(pd.ld_defss)) {
            if (_d_defs.b_vsb == false) {
                continue;
            };
            _r.push(
                <TouchableOpacity
                    key={_idx}
                    onPress={_d_defs.onPrs}
                >
                    <View
                        key={1}
                        style={ [{ 
                            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
                            lineHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2, 
                            width: ic.gn_btnWNrm, 
                            backgroundColor: (_d_defs.b_rvs) ? ic.g_ccdWN : (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                            borderWidth: ic.gn_bdrWNrw,
                            borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                            borderRadius: ic.gn_bdrRdsNrm,
                            marginStart: 0,
                            marginEnd: 0,
                            marginTop: 0,
                            marginBottom: 0,
                            paddingStart: 0,
                            paddingEnd: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            flex: 1,
                            flexDirection: 'column',
                            justifyContent: 'center', 
                            alignItems: 'center',
                        }, _d_defs.stlBtn]}
                    >
                        <Text
                            key={1}
                            style={[{ 
                                fontSize: ic.gn_fontSizeNrm,
                                color: (_d_defs.b_rvs) ? (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd : ic.g_ccdWN,
                            }, _d_defs.stlPfx]}
                            numberOfLines={1}
                        >
                            { _d_defs.pfx }
                        </Text>
                    </View>
                </TouchableOpacity>
            );
        };
        //
        return (
            <>
                { (pd.b_vsb != false) ?
                    <View 
                        style={[{
                            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
                            width: ((pd.n_bdyW) ? pd.n_bdyW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            marginTop: 0,
                            marginBottom: 0,
                            paddingStart: 0,
                            paddingEnd: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            flexDirection: 'row',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                        }, pd.stlCta]}
                    >
                        {_r}
                    </View>
                : null}
            </>
        );
    }

    static Box (pd) {
      return (
        <View
          style={[{
            marginStart: 0,
            marginEnd: 0,
            marginTop: 0,
            marginBottom: 0,
            borderWidth: 0,
          }, pd.stlCta]}
        >
          { pd.children }
        </View>
      );
    }

    static Files (pd) {
        //
        //
        let _r = [];
        //
        for (let [_idx, _d_files] of bf.e(global.c?.state[pd.state])) {
            if (bf.f(_d_files) && _d_files.b_dlt != true) {
                _r.push(
                    <View
                        key={_idx}
                        style={{
                            height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }}
                    >
                        <View
                            key={-1}
                            style={{
                                height: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2,
                                width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - ic.gn_btnIconSize,
                                marginTop: 0,
                                marginBottom: 0,
                                marginLeft: 0,
                                marginRight: 0,
                            }}
                        >
                            { (_d_files.lct == 'ext') ?
                                <ce.Link
                                    key={-1}
                                    file={_d_files.file}
                                    stlLink={{
                                        color: '#ffaa00',
                                    }}
                                >
                                    {_d_files.name}
                                </ce.Link>
                            : (_d_files.lct == 'int') ?
                                <Text>
                                    {_d_files.name}
                                </Text>
                            : null }
                        </View>
                        <ce.BtnIcon
                            key={-2}
                            b_vsb={pd.b_edt}
                            iconName="trash"
                            onPrs={()=>{
                                if (_d_files.lct == 'int'){ // 内部ファイルの場合
                                    // list から ファイルを削除
                                    let _ld_files = global.c?.state[pd.state];
                                    // 削除対象が内部ファイルの場合
                                    _ld_files = bf.myCM_rmv(_ld_files, _d_files);
                                    global.c?.setState({
                                        [pd.state]: _ld_files,
                                    });
                                }; 
                                if (_d_files.lct == 'ext'){ // 外部ファイルの場合
                                    let _ld_files = global.c?.state[pd.state];
                                    _ld_files = bf.myCM_rmv(_ld_files, _d_files);
                                    _d_files.b_dlt = true;
                                    _ld_files.push(_d_files);
                                    global.c?.setState({
                                        [pd.state]: _ld_files,
                                    });
                                }; 
                            }}
                            stlBtn={{
                                backgroundColor: ic.gn_backCcd,
                            }}
                        />
                    </View>
                );
            };
        };
        //
        return (
            <>
                <ce.Lbl
                    key={-1}
                    
                    pfx={pd.pfx}
                    iconName={'plus'}
                    b_btnVsb={pd.b_edt}
                    onBtnPrs={()=>{
                        cf.myFS_pck_file()
                        .then(async (_d_files) => {
                            if ( global.c && pd.state && global.c?.state[pd.state]) {
                                global.c?.setState({
                                    [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                        _next.push(_d_files);
                                    }),
                                });
                            };
                        });
                    }}
                />
                {_r}
            </>
        );
    }

    static Ftr (pd) {
        //
        let _r = [];
        //
        const _fnc1 = (pd_defs) => {
          if (pd_defs.page) { // 内部画面の場合
//            cf.myRN_clr_pageInf()
//            .then(()=>{
              new Promise((_o_end1) => {
//bf.l('1127:{}'.f(pd_defs.sgcd_pageCmns))
                if (pd_defs.sgcd_pageCmns) {
                  cf.myRN_setCmns(pd_defs.sgcd_pageCmns)
                  .then(() => {
                    _o_end1()
                  });
                }
                else {
                  _o_end1();
                };
              })
              .then(()=>{
                let _d_pageInfs = { // pagePntKey の切り替えは Ftr では行わない
                  sgc_pageRole: pd_defs.role, // pageRole の切り替えにも対応
                  sgc_pageName: pd_defs.page,
                  sgc_pageMode: 'show',
                };
//bf.l('1144:{}'.f(_d_pageInfs))
                cf.myRN_move_fwd(_d_pageInfs);
              });
//            });
          };
          if (pd_defs.url) { // 外部URLの場合
            cf.myRN_open_url(pd_defs.url);
          };
        };
        //
        for (let [_key, _d_defs] of bf.e(pd.dd_defss[global.c?.state.sgc_pageRole])){
          if (_d_defs.b_vsb == false) {
            continue;
          };
            if (_d_defs.type == 'iconPfx'){
              _r.push(
                <ce.BtnIconPfx
                  key={_key}
                  iconName={_d_defs.iconName}
                  pfx={_d_defs.pfx}
                  onPrs={() => {
                    if (_d_defs.fnc == 'logout') {
                      cf.myRN_logout();
                    }
                    else {
                      _fnc1(_d_defs);
                    };
                  }}
                  n_cnt={(_d_defs.state) ? global.c?.state[_d_defs.state] : null}
                />
              );
            };
            if (_d_defs.type == 'pfx'){
                _r.push(
                    <TouchableOpacity
                        key={_key}
                        onPress={() => _fnc1(_d_defs)}
                    >
                        <View
                            style={{
                                height: ic.gn_ftrH,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: ic.gn_fontSizeNrm,
                                    color: ic.g_backCcd,
                                    margin: 'auto',
                                }}
                            >
                                {_d_defs.pfx}
                            </Text>
                        </View>
                    </TouchableOpacity>
                );
            };
            if (_d_defs.type == 'img-sch'){
                _r.push(
                    <TouchableOpacity
                        key={_key}
                        onPress={() => _fnc1(_d_defs)}
                    >
                        <View
                            style={{
                                height: ic.gn_ftrH,
                                width: ic.gn_ftrH,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Image
                                style={[{
                                    height: ic.gn_iconSizeNrm,
                                    width: ic.gn_iconSizeNrm / _d_defs.h * _d_defs.w,
                                    margin: 'auto',
                                }]}
                                source={'./icon-sch.png'}　// 文字列に変換しておかないと error が発生
                            />
                        </View>
                    </TouchableOpacity>
                );
            };
            if (_d_defs.type == 'img-msg'){
                _r.push(
                    <TouchableOpacity
                        key={_key}
                        style={{
                            height: ic.gn_ftrH,
                            width: ic.gn_ftrH,
                        }}
                        onPress={() => _fnc1(_d_defs)}
                    >
                        <View
                            style={{
                                height: ic.gn_ftrH,
                                width: ic.gn_ftrH,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Image
                                style={[{
                                    height: ic.gn_iconSizeNrm,
                                    width: ic.gn_iconSizeNrm / _d_defs.h * _d_defs.w,
                                    margin: 'auto',
                                }]}
                                source={'./icon-msg.png'}　// 文字列に変換しておかないと error が発生
                            />
                        </View>
                    </TouchableOpacity>
                );
            };
            if (_d_defs.type == 'img-usr'){
                _r.push(
                    <TouchableOpacity
                        key={_key}
                        style={{
                            height: ic.gn_ftrH,
                            width: ic.gn_ftrH,
                        }}
                        onPress={() => _fnc1(_d_defs)}
                    >
                        <View
                            style={{
                                height: ic.gn_ftrH,
                                width: ic.gn_ftrH,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            { (bf.f(global.c?.state.sgc_user_img)) ?
                                <Image
                                    style={[{
                                        height: ic.gn_iconSizeNrm,
                                        width: ic.gn_iconSizeNrm,
                                        marginTop: 'auto',
                                        marginBottom: 'auto',
                                        borderRadius: ic.gn_bdrRdsNrm,
                                    }]}
                                    source={{uri:cf.myRN_get_uri(global.c?.state.sgc_user_img)}}　// 文字列に変換しておかないと error が発生
                                />
                            :
                                <Icon
                                    name={'user'}
                                    color={(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd}
                                    size={ic.gn_iconSizeSml}
                                    style={{
                                        margin: 'auto',
                                    }}
                                />
                            }
                        </View>
                    </TouchableOpacity>
                );
            };
        };
        //
        if (bf.myCM_get_len(pd.dd_defss[global.c?.state.sgc_pageRole]) == 1) { // 要素が 1つの場合は表示しない, error が発生する場合は sgc_pageRole が誤っていないか確認
            _r = [];
        };
        //
        return (
            <View style={[{ 
                position: 'absolute',
                zIndex: 20,
                top: ic.gn_ftrY,
                left: 0,
                height: ic.gn_ftrH,
                width: ic.gn_w,
                flexDirection: 'row',
                justifyContent: 'space-around',
                alignItems: 'center',
                backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
                padding: ic.gn_mgnNrm,
                borderTopWidth: ic.gn_bdrWNrm,
                borderTopColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].ftrCcd : ic.gdd_ccdDefss.cmn.ftrCcd,
            }, pd.stlCta]}>
                {_r}
            </View>
        );
    }

    static Hdr (pd) {
        let _logo = '{}'.f(pd.logo)
        return (
            <View style={{ 
                position: 'absolute',
                zIndex: ic.gn_zIdxHdr,
                top: (global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY - ic.gn_hdrH : ic.gn_bdyY - ic.gn_hdrH,
                left: 0,
                height: ic.gn_hdrH,
                width: ic.gn_w,
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'center',
                backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderBottomWidth: ic.gn_bdrWNrm,
            }}>
                <View style={{
                    position: 'absolute',
                    zIndex: ic.gn_zIdxHdr + 1,
                    top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY - ic.gn_hdrH : ic.gn_bdyY - ic.gn_hdrH) + ic.gn_hdrBarH,
                    left: 0,
                    height: ic.gn_hdrH - ic.gn_hdrBarH,
                    width:ic.gn_btnWSml * 3,
                    marginLeft: ic.gn_mgnNrm,
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }}>
                    { (pd.b_logo) ?
                        <Image
                            style={[{
                                height: ic.gn_iconSizeLrg,
                                width: ic.gn_iconSizeLrg / ic.gn_logoH * ic.gn_logoW,
                            }]}
                            source={'./logo.png'} // you need logo.png at ./srn ※ 文字列に変換しておかないと error が発生
                        />
                    : null }
                    { (bf.f(pd.leftIconName) && !bf.f(pd.leftPfx) && pd.b_leftVsb != false) ?
                        ce.Icon({
                            name: pd.leftIconName,
                            n_size: 30,
                            ccd: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                            onPrs: pd.onLeftPrs,
                        })
                    : null }
                    { (bf.f(pd.leftPfx) && !bf.f(pd.leftIconName) && pd.b_leftVsb != false) ? // logo がある場合、leftPfx が改行される場合がある
                        ce.Btn({
                            pfx:pd.leftPfx, 
                            b_vsb:true,
                            stlCta:bf.myCM_upd({
                                width: ic.gn_btnWNrm,
                            }, pd.stlLeftCta),
                            stlBtn:bf.myCM_upd({
                                borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                                backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'flex-start',
                            }, pd.stlLeftBtn),
                            stlPfx:bf.myCM_upd({
                                color: ic.g_backCcd,
                            }, pd.stlLeftPfx),
                            onPrs:pd.onLeftPrs,
                        })
                    : null }
                    { (bf.f(pd.leftIconName) && bf.f(pd.leftPfx) && pd.b_leftVsb != false) ?
                        <ce.BtnIconPfx
                            iconName={pd.leftIconName}
                            pfx={pd.leftPfx}
                            onPrs={pd.onLeftPrs}
                        />
                    : null}
                    { (pd.b_sch) ?
                        <ce.BtnIconPfx
                            iconName='search'
                            pfx='検索'
                            onPrs={pd.onSchPrs}
                        />
                    : null}
                </View>
                <View
                    style={{
                        height: ic.gn_hdrH - ic.gn_hdrBarH,
                        width: ic.gn_w,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Text
                        style={[{
                            fontSize: ic.gn_fontSizeNrm,
                            //color: ic.g_fontCcdLrg,
                            color: ic.g_backCcd,
                            textAlign: 'center',
                        }]}
                    >
                        {pd.pfx}
                    </Text>
                </View>
                <View
                    style={{
                        position: 'absolute',
                        zIndex: ic.gn_zIdxHdr + 1,
                        top: (((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH) + ic.gn_hdrBarH,
                        right: 0,
                        height: ic.gn_hdrH - ic.gn_hdrBarH,
                        width:ic.gn_btnWSml * 3,
                        marginTop: 0,
                        marginBottom: 0,
                        marginRight: ic.gn_mgnNrm,
                        marginLeft: 0,
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                    }}
                >
                    { (pd.b_rhtVsb != false && bf.f(pd.rhtIconName) && bf.f(pd.rhtPfx)) ?
                      <ce.BtnIconPfx
                        iconName={pd.rhtIconName}
                        pfx={pd.rhtPfx}
                        onPrs={pd.onRhtPrs}
                      />
                    : null}
                    { (pd.b_subVsb != false && bf.f(pd.subIconName) && bf.f(pd.subPfx)) ?
                      <ce.BtnIconPfx
                        iconName={pd.subIconName}
                        pfx={pd.subPfx}
                        onPrs={pd.onSubPrs}
                      />
                    : null}
                </View>
            </View>
        );
    }
/*
                    { (pd.b_rhtVsb != false && bf.f(pd.rhtPfx) && !bf.f(pd.rhtIconName)) ? 
                        ce.Btn({
                            b_vsb:pd.b_rhtVsb,
                            pfx:pd.rhtPfx, 
                            stlCta:bf.myCM_upd({
                                width: ic.gn_btnWNrm,
                            }, pd.stlRhtCta),
                            stlBtn:bf.myCM_upd({
                                backgroundColor: ic.g_backCcd,
                                borderColor: ic.g_backCcd,
                            }, pd.stlRhtBtn),
                            stlPfx:pd.stlRhtPfx,
                            onPrs:pd.onRhtPrs
                        }) 
                    : null}
                    { (pd.b_rhtVsb != false && bf.f(pd.rhtIconName) && !bf.f(pd.rhtPfx)) ?
                        ce.Icon({
                            name: pd.rhtIconName,
                            n_size: 30,
                            ccd:ic.g_hdrCcd,
                            onPrs: pd.onRhtPrs,
                        }) 
                    : null}
                    {(pd.b_trs) ? 
                        <ce.BtnIconPfx
                            iconName='trash'
                            pfx='削除'
                            onPrs={pd.onTrsPrs}
                        />
                    : null }
 */

    static HdrTrs (pd) {
        return (
            <>
                { (pd.b_vsb) ?
                    <View style={{ 
                        position: 'absolute',
                        zIndex: ic.gn_zIdxHdr + 1,
                        top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH,
                        left: 0,
                        height: ic.gn_hdrH,
                        width: ic.gn_w,
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        borderBottomColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                        borderBottomWidth: ic.gn_bdrWNrm,
                        padding: ic.gn_mgnNrm,
                    }}>
                        <ce.BtnIconPfx
                            iconName='trash'
                            pfx='選択項目を削除'
                            onPrs={pd.onPrs}
                        />
                        <ce.BtnIconPfx
                            iconName='close'
                            pfx='キャンセル'
                            onPrs={pd.onCls}
                        />
                    </View>
                : null }
            </>
        );
    }

    static HdrSch (pd) {
        //
        if (pd.b_vsb == false) {
            return null;
        };
        // 
        return (
            <View style={{ 
                position: 'absolute',
                zIndex: ic.gn_zIdxHdr + 1,
                top: (((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) - ic.gn_hdrH) + ic.gn_hdrBarH,
                left: 0,
                height: ic.gn_hdrH - ic.gn_hdrBarH,
                width: ic.gn_w,

                paddingTop: ic.gn_mgnNrm,
                paddingBottom: ic.gn_mgnNrm,
                paddingLeft: ic.gn_mgnNrm,
                paddingRight: ic.gn_mgnNrm,

                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',

                backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderBottomColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                borderBottomWidth: ic.gn_bdrWNrm,
            }}>
                <View 
                    style={ [{
                        height: ic.gn_hdrH - ic.gn_mgnNrm * 2,
                        width: ic.gn_w - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,

                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                    }] }
                >
                    <Icon
                        name='search'
                        color={ic.g_backCcd}
                        size={ic.gn_iconSizeSml}
                    />
                    <TextInput 
                        editable={true}
                        multiline={false}
                        placeholder={(pd.phd) ? pd.phd : '検索文字を入力後に確定ください'}
                        placeholderTextColor={ic.g_backCcd}
                        style={{
                            width: ic.gn_w - ic.gn_mgnNrm - ic.gn_iconSizeSml - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,
                            color: ic.g_backCcd,
                            fontSize: ic.gn_fontSizeNrm,
                            borderWidth: ic.gn_bdrWNrw * 1.5,
                            borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                            borderRadius: ic.gn_bdrRdsNrm,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: ic.gn_mgnNrm,
                            marginRight: 0,
                            paddingTop: ic.gn_mgnNrm,
                            paddingBottom: ic.gn_mgnNrm,
                            paddingLeft: ic.gn_mgnNrm,
                            paddingRight: ic.gn_mgnNrm,
                            borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
                            minHeight: (pd.b_mln) ? ic.gn_fontSizeNrm * 8 : ic.gn_fontSizeNrm * 3,
                        }}
                        onChangeText={(_schKey)=>{
                          global.c?.setState({
                            sgcd_schs: bf.p(global.c?.state.sgcd_schs, _next => {
                              _next.word= _schKey;
                            }),
                          }, () => {
//bf.l('1560:{}'.f(global.c?.state.sgcd_schs.word))
                          });
                        }}
                        onSubmitEditing={()=>{
                          if (pd.onEnt) {
                            pd.onEnt();
                          };
                        }}
                    />
                </View>
                <ce.BtnIconPfx
                    iconName='close'
                    pfx='閉じる'
                    onPrs={pd.onCls}
                />
            </View>
        );
    }
/*
                        onChangeText={(_schKey)=>{
                            if (pd.onEnt) {
                                pd.onEnt(_schKey);
                            };
                        }}
 */
    static Icon (pd) {
        return (
            <TouchableOpacity onPress={()=>{if ( pd.onPrs != null ) { pd.onPrs(); };}}>
                <View
                    style={[{
                        justifyContent:'center',
                        alignItems:'center',
                        margin: 'auto',
                    }, pd.stlCta]}
                >
                    <Icon
                        name={pd.name}
                        color={pd.ccd}
                        size={(pd.n_size) ? pd.n_size : ic.gn_iconSizeNrm}
                    />
                </View>
            </TouchableOpacity>
        );
    }

    static Img (pd) {
        let _r = [];
        _r.push(
            <View
                key={1}
                style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <View
                    style={[{
                        height: ic.gn_iconSizeLrg,
                        width: ic.gn_iconSizeLrg,
                        marginLeft: ic.gn_mgnNrm,
                        marginRight: ic.gn_mgnNrm,
                    }, pd.stlCta]}
                >
                    { ((global.c != null && pd.state != null && bf.f(global.c?.state[pd.state])) || (bf.f(pd.uri))) ?
                        <Image
                            style={[{
                                height: ic.gn_iconSizeLrg,
                                width: ic.gn_iconSizeLrg,
                                borderRadius: ic.gn_bdrRdsNrm,
                            }, pd.stlImg]}
                            source={(global.c != null && pd.state != null) ? { uri: global.c?.state[pd.state]} : pd.uri}　// 文字列に変換しておかないと error が発生、pd.uri は require された文字列でないと image が表示されない
                        />
                    :
                        <View
                            style={{
                                height: '100%',
                                width: '100%',
                                backgroundColor: ic.g_ccdHP,
                                borderRadius: ic.gn_bdrRdsNrm,
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: ic.gn_fontSizeNrm,
                                    color: ic.g_ccdWN,
                                }}
                            >
                                {pd.msg}
                            </Text>
                        </View>
                    }
                </View>
            </View>
        );
        //
        return (
            <View>
                { (pd.pfx) ?
                    <View
                        style={{
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <Text 
                            style={ [{
                                fontSize: ic.gn_fontSizeSml,
                                color: ic.g_fontCcdSml,
                                paddingTop: ic.gn_mgnNrm,
                                paddingBottom: ic.gn_mgnNrm,
                                paddingLeft: 0,
                                paddingRight: 0,
                                fontWeight: 'bold',
                            }, pd.stlPfx] }
                        >
                            { pd.pfx }
                        </Text>
                    </View>
                : null }
                {(pd.b_edt == true) ?
                    <TouchableOpacity onPress={()=>{
                        if (pd.b_edt == true) {
                            cf.myIP_pick_img((_d_ress) => {
                                if ( global.c != null && pd.state != null ) {
                                    global.c?.setState({[pd.state]:String(_d_ress.uri)})
                                };
                                if (pd.onPrs) {
                                    pd.onPrs(_d_ress.uri);
                                };
                            }, 'image');
                        };
                    }}>
                        {_r}
                    </TouchableOpacity>
                :
                    _r
                }
            </View>
        );
    }

    static Imgs (pd) {
        //
        let _r = [];
        //
        bf.myCM_for_each(pd.ld_defss, (_d_defs, _idx) => {
            _r.push(
                <ce.Img
                    key={_idx}
                    
                    state={_d_defs.state}
                    b_edt={pd.b_edt}
                    msg={_d_defs.msg}
                    uri={_d_defs.uri}
                    stlCta={pd.stlCta}
                    stlImg={pd.stlImg}
                />
            );
        });
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <View
                        style={ [{
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }, pd.stlBox] }
                    >
                        <View>
                            { (pd.pfx) ?
                                <Text 
                                    style={ [{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        paddingTop: ic.gn_mgnNrm,
                                        paddingBottom: ic.gn_mgnNrm,
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                    }, pd.stlPfx] }
                                >
                                    { pd.pfx }
                                </Text>
                            : null }
                        </View>
                        <View
                            style={[{
                                marginTop: ic.gn_mgnLrg,
                                marginBottom: ic.gn_mgnLrg,
                                marginLeft: ic.gn_mgnNrm,
                                marginRight: ic.gn_mgnNrm,
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap:'wrap'                    
                            }, pd.stlBox]}
                        >
                            {_r}
                        </View>
                    </View>
                : null }
            </View>
        );
    }

    static Inp (pd) {

        const [_so_textInput, _setTextInput] = useState(null);
        const [_s_val, _setVal] = useState('');
        const [_s_dsp, _setDsp] = useState('');

        useEffect(()=>{
          if (global.c?.state[pd.state] || global.c?.state[pd.state] == ''){ // 空白の場合に更新が反映されないことを考慮
//            _setVal((pd.b_cmm) ? bf.myCM_cnv('cmm', global.c?.state[pd.state]) : global.c?.state[pd.state]);
//            _setVal((pd.o_stlVal) ? pd.o_stlVal({mode: 'on', val: global.c?.state[pd.state]}) : global.c?.state[pd.state]);
            _setVal(global.c?.state[pd.state]);
            _setDsp((pd.o_stlVal) ? pd.o_stlVal({mode: 'on', val: global.c?.state[pd.state]}) : global.c?.state[pd.state]);
            if (pd.onChg) {
              pd.onChg(global.c?.state[pd.state]);
            }
          };
        }, [global.c?.state[pd.state]]);

        useEffect(()=>{
          if (bf.f(pd.ctlVal)){ // 空白の場合に更新が反映されないことを考慮
            if (bf.f(pd.state)) { // clds でない state が指定されている場合
              global.c?.setState({
                [pd.state]: _ctlVal
              });
            }
            else { // clds であり state が指定されていない場合
              _setVal(pd.ctlVal);
              _setDsp((pd.o_stlVal) ? pd.o_stlVal({mode: 'on', val: pd.ctlVal}) : pd.ctlVal);
/*
              if (pd.onChg) {
                pd.onChg(pd.ctlVal, pd.d_ids);
              }
*/
              if (pd.onChgAsCld) {
                pd.onChgAsCld(pd.ctlVal, pd.d_ids);
              }
            }
          };
        }, [pd.ctlVal]);

        if (pd.b_vsb == false) {
            return null;
        }

        const _o_onBlur = () => {
//bf.l('_o_onBlur')
/*
          new Promise( _o_end1 => {
//            if (pd.b_cmm) { // comma の設定
            if (pd.o_stlVal) { // comma の設定
              _setDsp(pd.o_stlVal({mode:'on', val: _s_val}), () => {
                _o_end1();
              });
            }
            else {
              _o_end1();
            };
          })
          .then(() => {
*/
            if (pd.state) { // clds ではない場合
              if (pd.onBlur) {
                pd.onBlur(_s_val);
              };
            }
            else { // clds の場合＋（sch等の）通常の入力欄の場合
/*
              if (pd.onBlur) {
                pd.onBlur(_s_val, pd.d_ids);
              };
*/
              if (pd.onBlurAsCld) {
                pd.onBlurAsCld(_s_val, pd.d_ids);
              };
            };
//          });
        };

        const _o_onChangeText = (_s) => {
          if (_s != _s_val) { // 値に変更のあった場合
            _setVal(_s);
            if (pd.state) { // clds ではない場合
              global.c?.setState({
                [pd.state]: _s
              }, ()=>{ // 外部からの更新を考慮し、onChg は useEffect で実行
/*
bf.l('1979: {}'.f())
                if (pd.onChg) {
bf.l('1981')
                  pd.onChg(_s);
                };
*/
              });
            }
            else { // clds の場合＋（sch等の）通常の入力欄の場合
/*
              if (pd.onChg) {
                pd.onChg(_s, pd.d_ids);
              }
*/
              if (pd.onChgAsCld) {
                pd.onChgAsCld(_s, pd.d_ids);
              }
            };
            if (_so_textInput) {
              _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
                global.c?.setState({
                  sgcd_inpMsrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
                });
              })
            };
          };
        };

        const _o_onContentSizeChange = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
          if (_so_textInput) {
            _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
              global.c?.setState({
                sgcd_inpMsrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
              });
            })
          };
        };

        const _o_onFocus = (_e) => { // PCでは不要な処理のため、keyboard が表示されたときの配置調整は、textinput ではなく、画面ごとに行う
//          if (pd.b_cmm) { // comma の解除
//          if (pd.o_stlVal) { // comma の解除
//            _setDsp(pd.o_stlVal({mode:'off', val:_s_val}));
//          };
          if (_so_textInput) {
            _so_textInput.measure((originX, originY, width, height, pageX, pageY) => { // 選択した inp の位置を保存
              global.c?.setState({
                sgcd_inpMsrs: {x:pageX, y:pageY, w:width, h:height, ox:originX, oy:originY},
              });
            })
          };
/*
          if (pd.onFcs) { // Focus された場合の処理、modal を表示する場合などに使用
            if (pd.state) { // clds ではない場合
              pd.onFcs();
            }
            else { // clds の場合＋（sch等の）通常の入力欄の場合
              pd.onFcs(_s_val, pd.d_ids);
            };
          };
*/
          if (pd.state) { // clds ではない場合
            if (pd.onFcs) { // Focus された場合の処理、modal を表示する場合などに使用
              pd.onFcs();
            }
          }
          else { // clds の場合＋（sch等の）通常の入力欄の場合
            if (pd.onFcsAsCld) { // Focus された場合の処理、modal を表示する場合などに使用
              pd.onFcsAsCld(_s_val, pd.d_ids);
            };
          };
        };

        const _o_onLayout = () => {
          if (bf.f(_so_textInput) && pd.b_fcs == true) {
            _so_textInput.focus();
          };
          if (pd.onLay) {
            pd.onLay();
          };
        };

        const _stlTextInput = {
          color: ic.g_fontCcdNrm,
          fontSize: ic.gn_fontSizeNrm,
          borderWidth: ic.gn_bdrWNrw * 1.5,
//          borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
          borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : 'transparent',
          borderRadius: ic.gn_bdrRdsNrm,
          paddingTop: ic.gn_mgnNrm /2,
          paddingBottom: ic.gn_mgnNrm /2,
          paddingLeft: ic.gn_mgnNrm,
          paddingRight: ic.gn_mgnNrm,
          borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
          minHeight: ((pd.b_mln) ? ic.gn_fontSizeNrm * 3 : ic.gn_fontSizeNrm) + ic.gn_mgnNrm * 2 + ic.gn_mgnNrm * 2,
          textAlign: 'left',
          textAlignVertical: (cf.myRN_chk_os('a') && pd.b_mln) ? 'top' : null,
//          textAlignVertical: (cf.myRN_chk_os('a') && pd.b_mln) ? 'top' : 'center',
        };


/*
                    style={ [{
                      color: ic.g_fontCcdNrm,
                      fontSize: ic.gn_fontSizeNrm,
                      borderWidth: ic.gn_bdrWNrw * 1.5,
                      borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                      borderRadius: ic.gn_bdrRdsNrm,
                      paddingTop: ic.gn_mgnNrm,
                      paddingBottom: ic.gn_mgnNrm,
                      paddingLeft: ic.gn_mgnNrm,
                      paddingRight: ic.gn_mgnNrm,
                      borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
                      minHeight: ((pd.b_mln) ? ic.gn_fontSizeNrm * 3 : ic.gn_fontSizeNrm) + ic.gn_mgnNrm * 2 + ic.gn_mgnNrm * 2,
                      textAlign: 'left',
                      textAlignVertical: (cf.myRN_chk_os('a') && pd.b_mln) ? 'top' : null,
                    }, pd.stlInp] }
              }, pd.stlCta] }
 */
        return (
          <View
            key={-1}
            style={[{
              width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              maxWidth: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              marginTop: ic.gn_mgnNrm,
//              marginBottom: ic.gn_mgnNrm,
//              marginTop: 0,
              marginBottom: 0,
              marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
              marginRight: (pd.n_col) ? 0 : 'auto',
            }, pd.stlCta]}
          >
            <View 
              key={-1}
              style={ [{
              }]}
            >
                { (pd.pfx) ?
                  <ce.Lbl
                    key={-1}
                    pfx={pd.pfx}
                    stlPfx={pd.stlLbl}
                  />
                : null }
                { (pd.b_edt) ? 
                  <TextInput
                    key={-2}
                    editable={pd.b_edt}
                    placeholder={pd.phd}
                    multiline={pd.b_mln}
                    selectTextOnFocus={true}
                    style={[_stlTextInput, pd.stlInp]}
                    ref={(_o) => {
                      _setTextInput(_o);
                    }}
                    value={_s_val}
                    onBlur={_o_onBlur}
                    onChangeText={_o_onChangeText}
                    onContentSizeChange={_o_onContentSizeChange}
                    onFocus={_o_onFocus}
                    onLayout={_o_onLayout}
                    keyboardType={pd.kbdType}
                  />
                :
                  <>
                  { (pd.onPrs) ? 
                    <TouchableOpacity
                      onPress={() => {
                        if (pd.state) {
                          pd.onPrs();
                        }
                        else {
                          pd.onPrs(pd.d_ids);
                        };
                      }}
                    >
                      <Text
                        style={[_stlTextInput, pd.stlInp]} >{_s_dsp}</Text>
                    </TouchableOpacity>
                  :
                    <Text
                      style={[_stlTextInput, pd.stlInp]} >{_s_dsp}</Text>
                  }
                  </>
                }
                { (pd.d_btnDefs?.onBtnPrs) ?
                  <ce.BtnIcon
                    key={-3}
                    b_vsb={pd.b_edt}
                    iconName={pd.d_btnDefs?.btnIconName}
                    onPrs={()=>{
                      if (pd.d_btnDefs?.onBtnPrs) {
                        pd.d_btnDefs?.onBtnPrs(pd.d_ids);
                      };
                    }}
                    stlCta={{
                        position: 'absolute',
                        top: ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                        right: (pd.d_btnDefs?.onDltPrs) ? (ic.gn_mgnNrm + ic.gn_btnIconSize + ic.gn_mgnNrm) : ic.gn_mgnNrm,
                        backgroundColor: ic.gn_backCcd,
                    }}
                  />
                : null }
                { (pd.d_btnDefs?.onDltPrs) ?
                  <ce.BtnIcon
                    key={-4}
                    b_vsb={pd.b_edt}
                    iconName={'trash'}
                    onPrs={()=>{
                      if (pd.d_btnDefs?.onDltPrs) {
                        pd.d_btnDefs?.onDltPrs(pd.d_ids);
                      };
                    }}
                    stlCta={{
                        position: 'absolute',
                        top: ic.gn_mgnNrm + ic.gn_bdrWNrw * 1.5 / 2, // boderWidth 分を追加
                        right: ic.gn_mgnNrm,
                        backgroundColor: ic.gn_backCcd,
                    }}
                  />
                : null }
            </View>
            { (pd.d_btnDefs?.onHdrPrs) ?
              <ce.BtnIcon
                key={-2}
                b_vsb={true}
                iconName={pd.d_btnDefs?.hdrIconName}
                onPrs={()=>{
                  if (pd.d_btnDefs?.onHdrPrs) {
                    pd.d_btnDefs?.onHdrPrs(pd.d_ids);
                  };
                }}
                stlBtn={{
                  backgroundColor: ic.gn_backCcd,
                }}
                stlCta={{
                  position: 'absolute',
                  top: ic.gn_mgnNrm +  ic.gn_mgnNrm,
                  left: ic.gn_mgnNrm * (ic.gn_btnIconSize + ic.gn_mgnNrm) * ((pd.n_lyr || 1) - 1),
                  backgroundColor: ic.gn_backCcd,
                }}
              />
            : null }
          </View>
        );
    }

  static Lbl (pd) {
    if (pd.b_vsb == false) {
      return null;
    };

    return (
      <View
        key={-1}
        style={[{
          height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
//          width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
          width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : (((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW),
          maxWidth: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
//          marginTop: ic.gn_mgnNrm,
//          marginBottom: ic.gn_mgnNrm,
          marginTop: 0,
          marginBottom: 0,
          marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
          marginRight: (pd.n_col) ? 0 : 'auto',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }, pd.stlCta]}
      >
        <TouchableOpacity
          onPress={pd.onBtnPrs}
        >
          <Text 
            key={-1}
            style={[{
  //              height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
              fontSize: ic.gn_fontSizeSml,
              color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
  //              paddingTop: ic.gn_mgnNrm,
  //              paddingBottom: ic.gn_mgnNrm,
              paddingTop: 'auto',
              paddingBottom: 'auto',
              paddingLeft: 0,
              paddingRight: 0,
              fontWeight: 'bold',
            }, pd.stlPfx]}
          >
            { pd.pfx }
          </Text>
        </TouchableOpacity>
        <ce.BtnIcon
          key={-2}
          b_vsb={(pd.b_btnVsb != false && pd.onBtnPrs) ? true : false}
          iconName={(pd.iconName) ? pd.iconName : 'ellipsis-v'}
          onPrs={pd.onBtnPrs}
          stlCta={{
            position: 'absolute',
//                                top: 0,
                                top: ic.gn_btnIconSize * (1.0 - 0.6) / 2,
//                                right: 0,
//            top: ic.gn_mgnNrm,
            right: ic.gn_mgnNrm,
          }}
          stlBtn={{
            height: ic.gn_btnIconSize * 0.6,
            width: ic.gn_btnIconSize * 0.6,
            backgroundColor: ic.g_bdyCcd,
          }}
          stlIcon={[{
            color: '#555555',
          }, pd.stlIcon]}
        />
      </View>
    );
  }
/*
        <View
          key={-1}
          style={{
//            height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
//            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - (ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2),
            marginTop: 'auto',
            marginBottom: 'auto',
          }}
        >
        </View>
 */

    static Chb(pd) {
        //
        const [_sb_val, _setVal] = useState(false);
        useEffect(()=>{
            _setVal(pd.val);
        }, [pd.b_val])
        //
        return (
            <>
                { (pd.b_vsb) ?
                    <View
                        style={[{
                        }, pd.stlCta]}
                    >
                        <CheckBox 
                            disabled={false}
                            value={_sb_val}
                            onChange={()=>{
                                let _b_val = !_sb_val;
                                _setVal(_b_val);
                                if (pd.onChg) {
                                    pd.onChg(_b_val);
                                };
                            }}
                        />
                    </View>
                : null }
            </>
        );
    };

    static Clds(pd) {
      //
      if (pd.b_vsb == false) return null;

      const [_sld_sortss, _setSortss] = useState([]); // 並び順の項目 [{fld:'', dtn:'asc/desc/none'}]

      useEffect(() => { // 並び順の変更
        global.c?.setState({
          [pd.state]: bf.myCM_sort({
            ld_itemss: global.c?.state[pd.state], 
            ld_sortss: _sld_sortss,
          }), 
        });
      }, [
        _sld_sortss
      ]);

      useEffect(() => { // 並び順の変更
        if (bf.f(pd.ld_sortss)) {
          _setSortss(pd.ld_sortss);
        };
      }, [pd.ld_sortss]);

      for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) { // 二重上書きを防ぐため別出し

        _d_defs.onFcsAsCld = (pa_vals, pd_ids) => { // pd_ids は clds の二重登録を防ぐために必要（？）
          if (!pd_ids) return;
          if (_d_defs.onFcs){
            _d_defs.onFcs(bf.p(pd_ids, _next => {
              _next.val = pa_vals;
            }));
          };
        };

        if (!_d_defs.onChgAsCld) _d_defs.onChgAsCld = (pa_vals, pd_ids) => { // Pck を考慮し、pd.state への push および idx の設定は Chg で実施要
//bf.l('2364: {}, {}, {}'.f(pd.state, pd_ids, pa_vals))
          if (!pd_ids) return;
          if (String(pd_ids.fld).substr(0,5) == 'dummy') return; // dummy 項目で onChg をスキップ これがないと他の項目の onChg も機能しない模様
          let _pastVal = null;
          if (
            bf.f(pd.state) && 
            bf.f(pd_ids) && 
            bf.f(global.c?.state[pd.state]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx][pd_ids.fld])
          ){
            _pastVal = global.c?.state[pd.state][pd_ids.idx][pd_ids.fld];
          };

          let _nextVal = (pa_vals.key) ? pa_vals.key : pa_vals;

          if (_nextVal != _pastVal) { // 値が変更されている場合
            global.c?.setState({
              [pd.state]: bf.p(global.c?.state[pd.state], _next => {
//bf.l('2366: {}, {}, {}'.f(pd.state, pd_ids, pa_vals))
                let _idx = pd_ids.idx;
                if (_idx != 'new') { // 既存データの場合, 0 の場合 else となるため、undefined や null でることを確認 
                  _next[_idx][pd_ids.fld] = _nextVal;
                  _next[_idx].b_dlt = false;
                  _next[_idx].b_ups = true;
                  _next[_idx][pd_ids.prtFld] = pd_ids.prtKey || null; // pd.prtFld, pd.prtKey の場合は、第一要素の値が参照されてしまう
                }
                else { // 新規データの場合
//bf.l('2400: {}, {}'.f(pd_ids, pa_vals));
                  let _d = {
//                    '_KEY': 'new', // 
                    '_KEY': pd_ids.key, //  
                    [pd_ids.fld]: _nextVal,
                    b_dlt: false,
                    b_ups: true,
                    [pd_ids.prtFld]: pd_ids.prtKey || null, // pd.prtFld, pd.prtKey の場合は、第一要素の値が参照されてしまう
                  };                    
                  if ( pd.d_insDats ) {
                    _d = bf.c(pd.d_insDats, _d);                    
                  }
//bf.l('2412: {}'.f(_d));
//bf.l('2419:{}'.f(_next))
                  _next.push(_d);
                };
              }),
            }, () => {
//bf.l('2389: {}, {}, {}'.f(pd.state, pd_ids, pa_vals))
              if (_d_defs.onChg){
                _d_defs.onChg(bf.p(pd_ids, _next => { // pd_ids の next であることに注意
                  _next.idx = ((pd_ids.idx == 'new')) ? bf.myCM_get_len(global.c?.state[pd.state])-1 : pd_ids.idx;
                  _next.next = _nextVal;
                  _next.past = _pastVal;
                }));
              };
            }, () => {
            });
          };
        };

        // onChg によって pastVal が 常に更新されるため、onBlur の場合に nextVal と pastVal が異なることはありえない
        _d_defs.onBlurAsCld = (pa_vals, pd_ids) => { // Pck を考慮し、push および idx の設定は Chg で実施要
          if (!pd_ids) return;
          //
          let _pastVal = null;
          if (
            bf.f(pd.state) && 
            bf.f(pd_ids) && 
            bf.f(global.c?.state[pd.state]) &&
            bf.f(global.c?.state[pd.state]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx]) &&
            bf.f(global.c?.state[pd.state][pd_ids.idx][pd_ids.fld])
          ){
            _pastVal = global.c?.state[pd.state][pd_ids.idx][pd_ids.fld];
          };

          let _nextVal = (pa_vals.key) ? pa_vals.key : pa_vals;

          if (_d_defs.onBlur){
            _d_defs.onBlur(bf.p(pd_ids, _next => {
              _next.idx = (pd_ids.idx == 'new') ? bf.myCM_get_len(global.c?.state[pd.state])-1 : pd_ids.idx;
              _next.next = _nextVal;
              _next.past = _pastVal;
            }));
          };
        };

        if (_d_defs.b_dlt == true) {
          _d_defs.onDltPrsAsCld = (pd_ids) => { // pd_ids は clds の二重登録を防ぐために必要（？）
            if (!pd_ids) return;
            global.c?.setState({
              [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                _next[pd_ids.idx].b_dlt = true;
              }),
            }, () => {
              if (_d_defs.onDltPrs){
                _d_defs.onDltPrs(pd_ids);
              };
            });
          };
        };
      };
      //
      let _r = [];
        //
      let _i = 0;
        //
      let _o_new = () => {

        _i += 1;

        let _itemKey = bf.myCM_get_newKey(global.c?.state[pd.state]); // dff、ランダムな文字列を追加する必要あり？
//        let _itemKey = bf.myCM_get_newKey(global.c?.state[pd.state]); // dff、ランダムな文字列を追加する必要あり？
//bf.l('2481: {}'.f(_itemKey))
        //
        if (pd.b_spr != false && bf.myCM_get_len(pd.dd_defss) > 1) { // 複数項目の場合
          _r.push(ce._elm({
            type:'Spr',
          }, 'Spr.{}.{}.{}b'.f(
            _i,
            _itemKey,
            pd.prtKey || '0',
          )));
          //
        };
        let _pfx = pd.pfx;
        if (pd.b_oneTtl != true) {
          if (bf.f(_pfx)) {
//bf.l('2486: {}'.f(pd.stlLbl))
            _r.push(ce._elm({
              type:'Lbl',
              b_vsb: true,
              pfx: String(_pfx).f(_i),
              iconName: null,
              onBtnPrs: null,
              stlCta: null,
              stlPfx: pd.stlLbl,
            }, '{}.Lbl'.f(_itemKey)));
          };
        };

        let _r2 = [];

        for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) {

          let _d = bf.myCM_copy(_d_defs); // _d_defs そのものを更新しないために

          _d.b_vsb = _d.b_vsb || ((_d_defs.ob_vsb) ? _d_defs.ob_vsb(pd.d_prts, {}) : false);

          if ( _d_defs.ob_edt ) { // b_edt を Clds において拡張
            _d.b_edt = _d_defs.ob_edt(pd.d_prts, {});
          }

//          _d.pfx = _d.pfx || ((_d_defs.o_pfx) ? _d_defs.o_pfx({}) : '');
          _d.pfx = 
            (_d_defs.o_pfx) ? 
              _d_defs.o_pfx({}) 
            : (_d.pfx) ?
              _d.pfx
            : ''
          ;
          _d.pfx = (pd.b_ttl != false) ? _d.pfx : ''; // title の表示 

          _d.ini = _d_defs.ini || ((_d_defs.o_ini) ? _d_defs.o_ini(pd.d_prts, {}) : null);
//          _d.ini = null
          _d.ctlVal = null; // null でない場合にエラー発生？
//if (_defKey == 'it30b21k') bf.l('2524: {}, {}'.f(_defKey, _d.ini))

          _d.d_ids = {
            idx: 'new', // b_dlt == true を含む
            key: _itemKey, 
            fld: _defKey,
            prtFld: pd.prtFld,
            prtKey: pd.prtKey,
          };  // clds の二重登録を防ぐために必要
          _d.prtKey = _itemKey;
          _d.prtNmb = (_d_defs.type == 'Clds') ? _i : 1;

          if ( _d_defs.ob_newLine ) { // b_edt を Clds において拡張
            _d.b_newLine = _d_defs.ob_newLine({});
          }

          _d.onDltPrsAsCld = null; // 削除アイコンを表示しない 

          _d.d_prts = {};

          if ( _d_defs.oo_rlcFldPrs ) {
            _d.o_rlcFldPrs = _d_defs.oo_rlcFldPrs(pd.d_prts, {});
          }

          _d.b_newLine = true; // 新規登録後に Pck を初期化するために必要

          _r2.push(
            ce._elm(
              _d, 
              '{}.{}.{}.{}'.f(
                _i,
                _d.d_ids.key, 
                _d.d_ids.fld,
                pd.prtKey || '0',
              )
            )
          );
        };

        _r.push(
          <View
            key={_itemKey}
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            {_r2}
          </View>
        );

      };

      if (
        bf.myCM_get_len(pd.dd_defss) == 1 ||
        pd.b_oneTtl == true
      ) { // 単一項目の場合
        if (bf.f(pd.pfx)) {
//bf.l('2576: {}'.f(pd.stlLbl))
          _r.push(ce._elm({
            type:'Lbl',
            b_vsb: true,
            pfx: '{}'.f(pd.pfx),
            iconName: null,
            onBtnPrs: null,
            stlCta: null,
            stlPfx: pd.stlLbl,
          }, '{}.Lbl'.f('cmn')));
        };
      };
        
//      if (pd.b_ttl == false) { // 個別行にタイトルを表示しない場合
      if (pd.b_hdr == true) { // 個別行にタイトルを表示しない場合

        let _r2 = [];

        if (pd.b_withNo) {
          _r2.push(
            ce._elm({
              type:'Lbl',
              b_vsb: true,
              pfx: '番号',
              n_col: 3,
            }, '-1.No')
          );
        }

        for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) {
          _r2.push(ce._elm({
            type:'Lbl',
            b_vsb: true,
            pfx: _d_defs.pfx, // pd.pfx に {} が存在する場合に _i を出力
            b_btnVsb: (bf.i({fld:_defKey, dtn:'asc'}, _sld_sortss) || bf.i({fld:_defKey, dtn:'desc'}, _sld_sortss)) ? true : false,
            iconName:
              bf.i({fld:_defKey, dtn:'asc'}, _sld_sortss) ? 
                'chevron-down' 
              : 
                bf.i({fld:_defKey, dtn:'desc'}, _sld_sortss) ? 
                  'chevron-up'
                :
                  'minus'
            ,
            onBtnPrs: () => {
              if (_d_defs.d_btnDefs?.onLblBtnPrs) {
                _d_defs.d_btnDefs?.onLblBtnPrs({fld: _defKey});
              }
              else {
                if (!bf.f(_sld_sortss)) {
                  _setSortss([{
                    fld: _defKey,
                    dtn: 'asc',
                  }]);
                }
                else {
                  _setSortss(bf.p(_sld_sortss, _next => {
                    let _idx = 0;
                    if (_next[_idx].fld == _defKey) {
                      _next[_idx].dtn = (_next[_idx].dtn == 'asc') ? 'desc': 'asc';
                    }
                    else {
                      _next[_idx].fld = _defKey;
                      _next[_idx].dtn = 'asc';
                    }
                  }));
                }
              };
            },
            stlCta: null,
            stlPfx: pd.stlLbl,
            n_col: _d_defs.n_col
          }, 'ttl.{}'.f(_defKey)));
        }
        _r.push(
          <View
            key={'ttl'}
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              backgroundColor: ic.g_ccdWN, // ScrollView の stickyHeaderIndices を考慮し、背景色を固定
            }}
          >
            {_r2}
          </View>
        );
      } 

/*
      if (
        pd.b_vsb && 
        pd.b_edt && 
        pd.b_newLine != false &&
        pd.b_plcNewAtTop == true // new を上部に配置
      ) {
        _o_new();
      };
*/

      for (let [_itemIdx, _d_items] of bf.e(global.c?.state[pd.state])) {

        if ( pd.ob_ftr && pd.ob_ftr(_d_items) == false ) continue; // filter


        if ( pd.prtFld && pd.prtKey && _d_items[pd.prtFld] != pd.prtKey ) continue; // prtFld が設定されている場合、prtKey と prtFld の値が同一のもののみ出力対象
//if ( pd.prtFld && pd.prtKey ) bf.l('{}, {}'.f(_d_items[pd.prtFld], pd.prtKey))

        if (_d_items.b_dlt == true) { // 削除対象の場合
          continue;
        }

        if (pd.b_wotData == true && '{}'.f(_d_items['_KEY']).substr(0,3) != 'new') { //  without data の場合、new 以外は表示対象外
          continue;
        };

        _i += 1;

        if (bf.myCM_get_len(pd.dd_defss) > 1) { // 複数項目の場合
          if (pd.b_spr != false) {
            _r.push(ce._elm({
              type:'Spr',
            }, 'Spr.{}.{}.{}a'.f(
              _i,
              _d_items._KEY,
              pd.prtKey || '0',
            )));
          };
        };
//        let _pfx = pd.pfx;
        let _pfx = (pd.o_pfx) ? pd.o_pfx(_d_items) : pd.pfx || '';
        if (
          pd.b_ttl != false &&
          pd.b_oneTtl != true
        ) {
          if (bf.f(_pfx)) {
//bf.l('2709: {}'.f(pd.stlLbl))
            _r.push(ce._elm({
              type:'Lbl',
              b_vsb: true,
              pfx: String(_pfx).f(_i), // pd.pfx に {} が存在する場合に _i を出力
              iconName: null,
              onBtnPrs: null,
              stlCta: null,
//              stlPfx: null,
              stlPfx: pd.stlLbl,
            }, '{}.Lbl'.f(_d_items._KEY)));
          };
        }

        let _r2 = [];

        if (pd.b_withNo) {
          _r2.push(
            ce._elm({
              type:'Inp',
              b_vsb: true,
              b_edt: false,
              pfx: '',
              ctlVal: '{}'.f(_itemIdx+1), // pd.pfx に {} が存在する場合に _i を出力
              n_col: 3,
            }, '{}.No'.f(_d_items._KEY))
          );
        }

        for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) {

          let _d = bf.myCM_copy(_d_defs); // _d_defs そのものを更新しないために

          _d.b_vsb = _d.b_vsb || ((_d_defs.ob_vsb) ? _d_defs.ob_vsb(pd.d_prts, _d_items) : false);

          if ( _d_defs.ob_edt ) { // b_edt を Clds において拡張
            _d.b_edt = _d_defs.ob_edt(pd.d_prts, _d_items);
          }

//          _d.pfx = _d.pfx || ((_d_defs.o_pfx) ? _d_defs.o_pfx(_d_items) : '');
          _d.pfx = 
            (_d_defs.o_pfx) ? 
              _d_defs.o_pfx(_d_items) 
            : (_d.pfx) ?
              _d.pfx
            : ''
          ;
          _d.pfx = (pd.b_ttl != false) ? _d.pfx : ''; // title の表示 

          _d.d_ids = {
            idx: _itemIdx,
            key: _d_items._KEY, 
            fld: _defKey,
            prtFld: pd.prtFld,
            prtKey: pd.prtKey,
          };  // clds の二重登録を防ぐために必要

          _d.prtKey = _d_items._KEY;
          _d.prtNmb = (_d_defs.type == 'Clds') ? _i : 1;

          _d.d_prts = _d_items;

          if ( _d_defs.ob_newLine ) { // b_edt を Clds において拡張
            _d.b_newLine = _d_defs.ob_newLine(_d_items);
          }

          if (
            global.c?.state[pd.state] &&
            _d.d_ids && 
            _d.d_ids.key && 
            _d.d_ids.fld &&
            _d_items[_defKey]
          ) {
              _d.ini = _d_items[_defKey];
          }
          else {
//            _d.ini = _d_defs.ini || ((_d_defs.o_ini) ? _d_defs.o_ini(pd.d_prts, _d_items) : '');
            _d.ini = _d_defs.ini ?? ((_d_defs.o_ini) ? _d_defs.o_ini(pd.d_prts, _d_items) : '');
          };
          _d.ctlVal = _d.ini;
//bf.l('2820: {}, {}, {}, {}'.f(_d.ctlVal, _d.ini, _d_items[_defKey], _d_items));

          if (_d_defs.do_stlInps) {
            _d.stlInp = _d_defs.do_stlInps({
              idx: _itemIdx, 
              key: _d_items._KEY,
              fld: _defKey,
              d_vals: _d_items,
            });
          }

          if ( _d_defs.oo_rlcFldPrs ) {
            _d.o_rlcFldPrs = _d_defs.oo_rlcFldPrs(pd.d_prts, _d_items);
          }

          _r2.push(
            ce._elm(
              _d, 
              '{}.{}.{}.{}'.f(
                _i,
                _d.d_ids.key, 
                _d.d_ids.fld,
                pd.prtKey || '0',
              )
            )
          );

        };
        _r.push(
          <View
            key={_itemIdx}
            style={[{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }, (pd.do_stlRows) ? pd.do_stlRows({
              idx: _itemIdx, 
              key: _d_items._KEY,
              d_vals: _d_items,
            }) : null]}
          >
            {_r2}
          </View>
        );
      };

      if (
        pd.b_vsb && 
        pd.b_edt && 
        pd.b_newLine != false
//        pd.b_plcNewAtTop != true // new を下部に配置
      ) {
        _o_new();
/*
        _i += 1;
        //
        let _itemKey = bf.myCM_get_newKey(global.c?.state[pd.state]); // dff、ランダムな文字列を追加する必要あり？
        //
        if (pd.b_spr != false && bf.myCM_get_len(pd.dd_defss) > 1) { // 複数項目の場合
          _r.push(ce._elm({
            type:'Spr',
          }, 'Spr.{}.{}.{}b'.f(
            _i,
            _itemKey,
            pd.prtKey || '0',
          )));
          //
        };
        let _pfx = pd.pfx;
        if (pd.b_oneTtl != true) {
          if (bf.f(_pfx)) {
            _r.push(ce._elm({
              type:'Lbl',
              b_vsb: true,
              pfx: String(_pfx).f(_i),
              iconName: null,
              onBtnPrs: null,
              stlCta: null,
              stlPfx: null,
            }, '{}.Lbl'.f(_itemKey)));
          };
        };

        let _r2 = [];

        for (let [_defKey, _d_defs] of bf.e(pd.dd_defss)) {

          let _d = bf.myCM_copy(_d_defs); // _d_defs そのものを更新しないために

          _d.b_vsb = _d.b_vsb || ((_d_defs.ob_vsb) ? _d_defs.ob_vsb(pd.d_prts, {}) : false);

          if ( _d_defs.ob_edt ) { // b_edt を Clds において拡張
            _d.b_edt = _d_defs.ob_edt(pd.d_prts, {});
          }

          _d.pfx = _d.pfx || ((_d_defs.o_pfx) ? _d_defs.o_pfx({}) : '');
          _d.pfx = (pd.b_ttl != false) ? _d.pfx : ''; // title の表示 

          _d.ini = _d_defs.ini || ((_d_defs.o_ini) ? _d_defs.o_ini(pd.d_prts, {}) : null);
          _d.ctlVal = null; // 空白行の場合は常に null で良い？ 

          _d.d_ids = {
            idx: 'new', // b_dlt == true を含む
            key: _itemKey, 
            fld: _defKey,
            prtFld: pd.prtFld,
            prtKey: pd.prtKey,
          };  // clds の二重登録を防ぐために必要
          _d.prtKey = _itemKey;
          _d.prtNmb = (_d_defs.type == 'Clds') ? _i : 1;

          if ( _d_defs.ob_newLine ) { // b_edt を Clds において拡張
            _d.b_newLine = _d_defs.ob_newLine({});
          }

          _d.onDltPrsAsCld = null; // 削除アイコンを表示しない 

          _d.d_prts = {};

          if ( _d_defs.oo_rlcFldPrs ) {
            _d.o_rlcFldPrs = _d_defs.oo_rlcFldPrs(pd.d_prts, {});
          }

          _d.b_newLine = true; // 新規登録後に Pck を初期化するために必要

          _r2.push(
            ce._elm(
              _d, 
              '{}.{}.{}.{}'.f(
                _i,
                _d.d_ids.key, 
                _d.d_ids.fld,
                pd.prtKey || '0',
              )
            )
          );
        };

        _r.push(
          <View
            key={_itemKey}
            style={{
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            {_r2}
          </View>
        );
*/

      };

      if (pd.b_spr != false && bf.myCM_get_len(pd.dd_defss) > 1 && bf.myCM_get_len(global.c?.state[pd.state]) > 0) { // 複数項目の場合
        _r.push(ce._elm({
          type:'Spr',
        }, '{}.Spr'.f('last')));
      };

      const [_so_scrView, _setScrView] = useState(null);

      return (
        <ScrollView
          stickyHeaderIndices={[0]} // 一行目を見出しとして表示を固定
          style={[{
          }, pd.stlCta]}
        >
          {_r}
        </ScrollView>
      );
    };

/*
          ref={(_o) => {
              _setScrView(_o);
          }}
          onContentSizeChange={(_w, _h)=> {
bf.l('2941: {}'.f(_h))
            if (_so_scrView) {
bf.l('2943: {}'.f(_h))
              _so_scrView.scrollTo({
                y: 1000,
                animated: true,
              });
            };
          }}
 */

  static List = (pd={
  }) => { // 辞書型の場合、ソートできない？
    //
    if (pd.b_vsb == false) {
      return null;
    };
    //
    let _r = [];
    //
    let _ld_itemss = {};
    if (pd.state) {
      _ld_itemss = global.c?.state[pd.state];
    }
    else if (pd.ld_itemss) {
      _ld_itemss = pd.ld_itemss;
    }
    else {
      return null;
    };
    //
    let _n_cnt = 0;
    let _n_sum = 0;
    let _pastDate = '';
    //
    for (let [_idx, _d_items] of bf.e(_ld_itemss)) {
      //
      if (pd.sumFld && pd.dtmFld) {
        if (_pastDate != _d_items.val[pd.dtmFld].substr(0,10)) {
          if (_pastDate != '') {
            _n_cnt -= 1;
            _r.push(
              <View
                key={_n_cnt}
                style={{
                  height: 10 + ic.gn_bdrWNrw * 2,
                  width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                  marginTop: ic.gn_mgnLrg,
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  backgroundColor: '#e9e9e9',
                  borderWidth: ic.gn_bdrWSml,
                  borderRadius: ic.gn_bdrRdsNrm,
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Text
                  key={1}
                  style={{
                    fontSize: 10,
                    color: '#444444',
                  }}
                >
                  {'{} {}円'.f(_pastDate, _n_sum)}
                </Text>
              </View>
            );
          };
          _pastDate = _d_items.val[pd.dtmFld].substr(0,10)
          _n_sum = 0;
        };
        _n_sum += bf.n(_d_items.val[pd.sumFld]);
      };

      _r.push(
        <View
          key={_idx}
          style={{
            marginTop: ic.gn_mgnSml,
            marginBottom: ic.gn_mgnSml,
            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <ce.Row
            key={-1}
          >
            { (pd.b_chb) ?
              <ce.Chb
                key={-1}
                b_vsb={true}
                onChg={(_b_val)=>{
                  if (pd.onChk){
                    pd.onChk(_d_items, _b_val);
                  }
                }}
                stlCta={{
                }}
              />
            : null }
            <TouchableOpacity
              key={-2}
              onPress={()=>{
                if (pd.onPrs && pd.b_prs != false) {
                  pd.onPrs(_d_items, _idx);
                };
              }}
            >
              <View
                key={-1}
                style={{
                  width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - ((pd.b_chb) ? ic.g_chbW : 0),
                  paddingTop: ic.gn_mgnLrg,
                  paddingBottom: ic.gn_mgnLrg, // 0 is good for chat
                  paddingLeft: ic.gn_mgnNrm, // 0 is good for chat
                  paddingRight: ic.gn_mgnNrm,
                  borderWidth: 1,
                  borderColor: (pd.b_prs == true && pd.b_bdr != false) ? '#bbbbbb' : ic.g_ccdWN,
                  borderRadius: 0,
                  backgroundColor: (_d_items.backCcd) ? _d_items.backCcd : null,
                }}
              >
                <ce.Row
                  key={-1}
                >
                  { (pd.b_img) ? // (_d_items.uri) ?
                    <ce.Img
                      key={-1}
                      stlCta={{
                        height: ic.gn_iconSizeLrg,
                        width: ic.gn_iconSizeLrg,
                        marginTop: ic.gn_mgnNrm,
                        marginBottom: 'auto',
                        marginLeft: 0,
                        marginRight: ic.gn_mgnNrm,
                      }}
                      stlImg={{
                        width: ic.gn_iconSizeLrg,
                        height: ic.gn_iconSizeLrg,
                      }}
                      uri={_d_items.uri}
                      msg={_d_items.pfx.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                    />
                  : null}
                  <View
                    key={-2}
                    style={{
                      width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 4 - ic.gn_scbW - ((pd.b_chb) ? ic.g_chbW : 0) - ((!bf.f(_d_items.uri) == false) ? ic.gn_iconSizeLrg + ic.gn_mgnNrm : 0)
                    }}
                  >
                    <Text
                      key={-1}
                      style={{
                        fontSize: ic.gn_fontSizeNrm,
                        color: ic.g_fontCcdNrm,
                      }}
                    >
                      {_d_items.pfx}
                    </Text>
                    <Text
                      key={-2}
                      style={[{
                        fontSize: ic.gn_fontSizeSml,
                        color: ic.g_fontCcdSml,
                        marginRight: ic.gn_mgnNrm,
                        marginLeft: 'auto',
                      }]}
                    >
                      {_d_items.spf}
                    </Text>
                  </View>
                </ce.Row>
              </View>
            </TouchableOpacity>
          </ce.Row>
        </View>
      );
    };
    //
    if (pd.sumFld && pd.dtmFld) {
      _n_cnt -= 1;
      _r.push(
        <View
          key={_n_cnt}
          style={{
            height: 10 + ic.gn_bdrWNrw * 2,
            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
            marginTop: ic.gn_mgnLrg,
            marginLeft: 'auto',
            marginRight: 'auto',
            backgroundColor: '#e9e9e9',
            borderWidth: ic.gn_bdrWSml,
            borderRadius: ic.gn_bdrRdsNrm,
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Text
            key={1}
            style={{
              fontSize: 10,
              color: '#444444',
            }}
          >
            {'{} {}円'.f(_pastDate, _n_sum)}
          </Text>
        </View>
      );
    };
    //
    return (
      <View
          key={-1}
          style={{
          }}
      >
        <ce.Lbl
          key={-1}
          b_vsb={(pd.pfx) ? true : false}          
          pfx={pd.pfx}
          stlCta={{
          }}
          stlPfx={{
              fontSize: ic.gn_fontSizeLrg,
              color: ic.g_fontCcdLrg,
          }}
          iconName={pd.iconName}
          onBtnPrs={pd.onBtnPrs}
        />
        {_r}
      </View>
    );
  }

    static ListBean (pd) {
        //
        let _n_col = 4; // 列数
        let _n_w = (ic.gn_w - ic.gn_scbW - ic.gn_mgnNrm * ( _n_col + 1)) / _n_col; 
        //
        let _r = [];
        bf.myCM_for_each(global.c?.state[pd.state], (_d_items) => {
            _r.push(
                <View
                    style={{
                        height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                        width:  _n_w + ic.gn_fontSizeNrm,
                        margin: ic.gn_mgnNrm / 2,
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <View
                        style={{
                            height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                            width: _n_w,
                            borderWidth: ic.gn_bdrWNrw,
                            borderRightWidth: 0,
                            borderColor: ic.g_bdrCcd,
                            borderTopLeftRadius: ic.gn_bdrRdsLrg,
                            borderBottomLeftRadius: ic.gn_bdrRdsLrg,
                            marginLeft: ic.gn_mgnNrm / 2,
                            marginRight: 0,
                            paddingHorizontal: ic.gn_mgnNrm,
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Text
                            style={{
                                color: ic.g_fontCcdNrm,
                                fontSize: ic.gn_fontSizeSml,
                            }}
                            numberOfLines={1}
                            ellipsizeMode='tail'
                        >
                            {_d_items.pfx}
                        </Text>
                    </View>
                    <TouchableOpacity
                        onPress={() => {
                            (pd.onPrs) ? pd.onPrs(_d_items) : null
                        }}
                    >
                        <View
                            style = {{
                                height: ic.gn_fontSizeSml + ic.gn_mgnNrm * 2,
                                width: ic.gn_fontSizeNrm,
                                borderWidth: ic.gn_bdrWNrw,
                                borderLeftWidth: 0,
                                borderColor: ic.g_bdrCcd,
                                borderTopRightRadius: ic.gn_bdrRdsLrg,
                                borderBottomRightRadius: ic.gn_bdrRdsLrg,
                                marginLeft: 0,
                                marginRight: ic.gn_mgnNrm / 2,
                            }}
                        >
                            <Text
                                style={{
                                    color: ic.g_fontCcdNrm,
                                    fontSize: ic.gn_fontSizeSml,
                                }}
                            >
                                ×
                            </Text>
                        </View>
                    </TouchableOpacity>
                </View>
            );
        });
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexWrap: 'wrap',
                            }}
                        >
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

/*
listcard の無限スクロールへの対応について <- useContext により改善される？
・本来は、listcard ごとに scroll bottom を判定し、追加で読み込むべきであるが、tecs では、下記の３点により対応を見送る
・rootlist が複数の listcart に対応していることから、
　listcard を横方向スクロールとする必要がある
・body ではなく listcard の scrollview をもとにスクロールするよう変更する必要がある
・listcard にイベントを送るため、例えば、listcard に 表示行数等の state を保持し、
　その state を rootlist において更新する必要がある？　←　いらなくなるかも

*/

    static ListCard (pd) {
        //
        let _n_col = (!bf.f(pd.n_col) == false) ? pd.n_col : 2;
        let _n_cnt = 0;
        let _n_w = (((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * (_n_col + 1)) / _n_col;
        //
        let _r1 = [];
        let _r2 = [];
        bf.myCM_for_each(global.c?.state[pd.state], (_d_items, _idx) => {
            _r1.push(
                <View
                    key={_idx}
                    style={{
                        marginTop: 0,
                        marginBottom: 'auto',
                        marginStart: 'auto',
                        marginEnd: 'auto',
                    }}
                >
                    <TouchableOpacity
                        onPress={()=>{
                            (pd.onPrs) ? pd.onPrs(_d_items) : null;
                        }}
                    >
                        <View style={{
                            width: _n_w,
                            borderWidth: 1,
                            borderColor: (pd.onPrs && pd.b_bdr != false) ? '#bbbbbb' : ic.g_ccdWN,
                            borderRadius: 0,
                            paddingTop: ic.gn_mgnLrg,
                            paddingBottom: ic.gn_mgnLrg, // 0 is good for chat
                            paddingLeft: ic.gn_mgnNrm / 2, // 0 is good for chat
                            paddingRight: ic.gn_mgnNrm / 2,
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }}>
                            { (pd.b_img) ?
                                <ce.Img
                                    b_edt={false}
                                    stlCta={{
                                        height: _n_w - ic.gn_mgnNrm,
                                        width: _n_w - ic.gn_mgnNrm,
                                        margin: 0,
                                    }}
                                    stlImg={{
                                        height: _n_w - ic.gn_mgnNrm,
                                        width: _n_w - ic.gn_mgnNrm,
                                    }}
                                    uri={_d_items.uri}
                                    msg={_d_items.pfx.replace(/ /g, '').replace(/　/g, '').substring(0,2)}
                                />
                            : null }
                            <View
                                style={{
                                    width: _n_w - ic.gn_mgnNrm,
                                }}
                            >
                                <Text
                                    style={{
                                        fontSize: ic.gn_fontSizeNrm,
                                        color: ic.g_fontCcdNrm,
                                        marginRight: 'auto',
                                        marginLeft: 'auto',
                                    }}
                                >
                                    {_d_items.pfx}
                                </Text>
                                <Text
                                    style={[{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        marginRight: 'auto',
                                        marginLeft: 'auto',
                                    }]}
                                >
                                    {_d_items.spf}
                                </Text>
                            </View>
                        </View>
                    </TouchableOpacity>
                </View>
            );
            //
            _n_cnt += 1;
            if ( _n_cnt >= _n_col ) {
                _n_cnt = 0;
                _r2.push(
                    <ce.Row
                        key={_idx}
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        {_r1}
                    </ce.Row>
                );
                _r1 = [];
            };
        });
        // 残り分
        _r2.push(
            <ce.Row
                key={-1}
                style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                }}
            >
                {_r1}
            </ce.Row>
        );
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            padding: 0,
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                            marginTop: ic.gn_mgnNrm,
                            marginBottom: ic.gn_mgnNrm,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View>
                            <View>
                                { (pd.pfx) ?
                                    <ce.Row
                                        stlCta={{
                                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                                            marginTop: ic.gn_mgnNrm * 3,
                                            marginBottom: ic.gn_mgnNrm,
                                            marginLeft: 'auto',
                                            marginRight: 'auto',
                                            borderColor: ic.g_bdrCcd,
                                            borderBottomWidth: ic.gn_bdrWNrw,
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <ce.Lbl
                                            
                                            pfx={pd.pfx}
                                            stlCta={{
                                            }}
                                            stlPfx={{
                                                fontSize: ic.gn_fontSizeSml,
                                                color: ic.g_fontCcdSml,
                                                paddingTop: ic.gn_mgnNrm,
                                                paddingBottom: ic.gn_mgnNrm,
                                                paddingLeft: 0,
                                                paddingRight: 0,
                                                fontWeight: 'bold',
                                            }}
                                        />
                                        { (pd.b_menu) ?
                                            <TouchableOpacity
                                                onPress={()=>{
                                                    global.c?.setState({ // menu の表示
                                                        sgcb_menu: true
                                                    });
                                                }}
                                            >
                                                <View
                                                    style={{
                                                        height: ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2,
                                                        width: ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2,
                                                        backgroundColor: '#dddddd',
                                                        borderColor: '#dddddd',
                                                        borderRadius: (ic.gn_fontSizeLrg + ic.gn_mgnNrm * 2)/2,
                                                    }}
                                                >
                                                    <Icon
                                                        name="ellipsis-v"
                                                        type="FontAwesome"
                                                        underlayColor="transparent"
                                                        size={ic.gn_fontSizeLrg}
                                                        color={'#555555'}
                                                        style={{
                                                            marginTop: 'auto',
                                                            marginBottom: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                        }}
                                                    />
                                                </View>
                                            </TouchableOpacity>
                                        : null }
                                        { (pd.btnPfx) ?
                                            <ce.Btn
                                                b_vsb={true}
                                                pfx={pd.btnPfx}
                                                stlCta={{
                                                    width:ic.gn_fontSizeSml * 3,
                                                }}
                                                stlBtn={{
                                                    width:ic.gn_fontSizeSml * 3,
                                                    marginLeft: ic.gn_mgnNrm,
                                                    borderWidth: ic.gn_bdrWNrw,
                                                    borderColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                                                    backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                                                    padding: ic.gn_mgnSml,
                                                }}
                                                stlPfx={{
                                                    fontSize: ic.gn_fontSizeSml,
                                                    color: ic.g_ccdWN,
                                                }}
                                                onPrs={pd.onBtnPrs}
                                            />
                                        : null }
                                    </ce.Row>
                                : null }
                            </View>
                            {_r2}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

    static ListChat (pd) {
        //
        let _r = [];
        //
        let _pastDate = '';
        let _pastTime = '';
        //
        let _cnt = 1; // 初期値分シフト
        //
        for (let [_idx, _d_items] of bf.e(global.c?.state[pd.state])) {
            //
            if (_pastDate != _d_items.time.substr(0,10)) {
                _cnt += 1;
                _r.push(
                    <View
                        key={_cnt}
                        style={{
                            height: 10 + ic.gn_bdrWNrw * 2,
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                            marginTop: ic.gn_mgnLrg,
                            backgroundColor: '#e9e9e9',
                            borderWidth: ic.gn_bdrWSml,
                            borderRadius: ic.gn_bdrRdsNrm,
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Text
                            key={1}
                            style={{
                                fontSize: 10,
                                color: '#444444',
                            }}
                        >
                          {_d_items.time.substr(0,10)}
                        </Text>
                    </View>
                );
                //
                _pastDate = _d_items.time.substr(0,10)
            };

            //
            _cnt += 1;
            _r.push(
                <ce.Row
                    key={_cnt}
                    stlCta={{
                        width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                        marginTop: 0,
                        marginBottom: 0,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        paddingTop: 0,
                        paddingBottom: 0, // 0 is good for chat
                        paddingLeft: 0, // 0 is good for chat
                        paddingRight: 0,
                        borderWidth: 0,
                        flexDirection: 'row',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    }}
                >
                    { (pd.b_avt) ?
                        <ce.Img
                            key={1}
                            stlCta={{
                                height: ic.gn_iconSizeLrg,
                                width: ic.gn_iconSizeLrg,
                                marginTop: 0,
                                marginBottom: 'auto',
                                marginLeft: 0,
                                marginRight: ic.gn_mgnNrm,
                            }}
                            stlImg={{
                                height: ic.gn_iconSizeLrg,
                                width: ic.gn_iconSizeLrg,
                                marginTop: 0,
                                marginBottom: 0,
                                marginLeft: 0,
                                marginRight: 0,
                            }}
                            uri={_d_items.uri}
                        />
                    : null }
                    <View
                        key={2}
                        style={{
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2 - ((pd.b_avt) ? (ic.gn_iconSizeLrg + ic.gn_mgnNrm) : 0),
                            marginTop: 0,
                            marginBottom: 0,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                    >
                        { (_pastTime != _d_items.time.substr(0,16)) ?
                            <Text
                                key={1}
                                style={{
                                    width: '100%',
                                    marginTop: ic.gn_mgnLrg,
                                    fontSize: ic.gn_fontSizeSml * 0.85,
                                    color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                                    fontWeight: 'bold',
                                }}
                            >
                                {_d_items.name}（{_d_items.time}）
                            </Text>
                        : null }
                        <Text
                            key={2}
                            style={[{
                                fontSize: ic.gn_fontSizeNrm,
                                color: ic.g_fontCcdNrm,
                                marginTop: 0,
                                marginBottom: 0,
                            }]}
                        >
                            { (_d_items.type == 'msg') ? 
                                <Text
                                    key={1}
                                    style={{
                                        marginTop: 0,
                                        marginBottom: 0,
                                    }}
                                >
                                    {_d_items.msg}
                                </Text>
                            : (_d_items.type == 'file') ? 
                                <ce.Link
                                    key={1}
                                    
                                    file={_d_items.file}
                                    stlLink={{
                                        color: '#ffaa00',
                                    }}
                                >
                                    {_d_items.file.name}
                                </ce.Link>
                            : null }
                        </Text>
                    </View>
                </ce.Row>
            );
            //
            _pastTime = _d_items.time.substr(0,16);
        };
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        key={1}
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            key={1}
                        >
                            <View
                                key={-1}
                            >
                                { (pd.pfx) ?
                                    <ce.Lbl
                                        key={-1}
                                        
                                        pfx={pd.pfx}
                                        stlCta={{
                                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,

                                            marginTop: ic.gn_mgnLrg,
                                            marginBottom: ic.gn_mgnLrg,
                                            marginLeft: 'auto',
                                            marginRight: 'auto',

                                            borderColor: ic.g_bdrCcd,
                                            borderBottomWidth: ic.gn_bdrWNrw,
                                        }}
                                        stlPfx={{
                                            fontSize: ic.gn_fontSizeLrg,
                                            color: ic.g_fontCcdLrg,
                                        }}
                                    />
                                : null }
                            </View>
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

    static ListEnt (pd) { // list entry
        //
        if (pd.b_vsb == false) { // b_vsb == false の場合は非表示
            return null;
        }
        //
        let _r = [];
        //
        let _pastHdr = '';
        //
        let _cnt = 0;
        for (let [_key, _d_items] of bf.e(global.c?.state[pd.state])) {
            //
            _cnt += 1;
            if(_d_items.hdr == _pastHdr) {
            }
            else {
                _r.push(
                    <View
                        key={_cnt}
                        style={{
                            width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginTop: ic.gn_mgnSml,
                            marginBottom: ic.gn_mgnSml,
                            marginLeft: 'auto',
                            marginRight: 'auto',
                        }}
                    >
                        <ce.Msg
                            key={-1}
                            pfx={_d_items.hdr}
                            stlPfx={(pd.stlHdr) ? pd.stlHdr : null}
                        />
                    </View>
                );
            };
            //
            _pastHdr = _d_items.hdr;
            //
            _cnt += 1;
            _r.push(
                <View
                    key={_cnt}
                    style={{
                        width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                        marginTop: ic.gn_mgnSml,
                        marginBottom: ic.gn_mgnSml,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <ce.Msg
                        key={-1}
                        pfx={_d_items.msg}
                    />
                    <ce.Msg
                        key={-2}
                        pfx={'{}時点'.f(_d_items.dtm)}
                        stlPfx={{
                            fontSize: ic.gn_fontSizeSml,
                        }}
                    />
                    <ce.Inp
                        key={-3}
                        b_vsb={true}
                        b_edt={pd.b_edt}                        
                        state={null}
                        pfx={null}
                        b_mln={true}
                        ini={_d_items.ini}
                        phd={null}
                        onFcs={null}
                        onBlur={(_s) => {
                            global.c?.setState({
                                [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                    _next[_key].val = _s;
                                }),
                            });                            
                        }}
                        stlCta={null}
                        stlInp={null}
                    />
                </View>
            );
        };
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }, pd.stlCta]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            key={-1}
                        >
                            <View
                                key={-1}
                            >
                                { (pd.pfx) ?
                                <ce.Row
                                    key={-1}
                                    stlCta={{
                                        width: ((pd.n_w) ? pd.n_w : ic.gn_w) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                                        marginTop: ic.gn_mgnNrm * 3,
                                        marginBottom: ic.gn_mgnNrm,
                                        marginLeft: ic.gn_mgnNrm,
                                        marginRight: ic.gn_mgnNrm,
                                        borderColor: ic.g_bdrCcd,
                                        borderBottomWidth: ic.gn_bdrWNrw,
                                        flexDirection: 'row',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    <ce.Lbl
                                        key={-1}
                                        
                                        pfx={pd.pfx}
                                        stlCta={{
                                        }}
                                        stlPfx={{
                                            fontSize: ic.gn_fontSizeLrg,
                                            color: ic.g_fontCcdLrg,
                                        }}
                                    />
                                </ce.Row>
                                : null }
                            </View>
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

    static InpTree (pd) { // inputs
        //
        if (pd.b_vsb == false) { // b_vsb == false の場合は非表示
            return null;
        }
        //
        function _fnc01(pd_items) {
            return(
                <View
                    key={pd_items.pid}
                    style={{
                        width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                        marginTop: ic.gn_mgnSml,
                        marginBottom: ic.gn_mgnSml,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}
                >
                    <ce.Inp
                        key={-1}
                        b_vsb={true}
                        b_edt={pd.b_edt}
                        state={null}
                        pfx={null}
                        b_mln={false}
                        ini={pd_items.ini}
                        phd={pd.phd}
                        n_pntW={((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW - (pd_items.n_lyr - 1) * ic.gn_fontSizeNrm * 2}
                        onFcs={null}
                        onBlur={(_s) => {
                            global.c?.setState({
                                [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                    //
                                    let _cpt = _next;
                                    //
                                    for (let [_n_idx, _key] of bf.e(pd_items.pid.split(bf.dlm))) {
                                        //
                                        if (_n_idx >= pd_items.n_lyr - 0) { // 同階層を取得
                                            break;
                                        }
                                        //
                                        if (_n_idx == 0) {
                                            if (!bf.f(_cpt[_key])) {
                                                _cpt[_key] = {
                                                    ini: '',
                                                    clds: {},
                                                };
                                            };
                                            _cpt = _cpt[_key];
                                        }
                                        else {
                                            if (!bf.f(_cpt.clds[_key])) {
                                                _cpt.clds[_key] = {
                                                    ini: '',
                                                    clds: {},
                                                };
                                            };
                                            _cpt = _cpt.clds[_key];
                                        };
                                    };
                                    //
                                    _cpt.val = _s;
                                }),
                            });

                            global.c?.setState({
                                sgcd_items: pd_items,
                            }, ()=>{
                            });
                        }}
                        stlCta={{
                            marginLeft: 'auto',
                            marginRight: 0,
                        }}
                        stlInp={null}
                    />
                </View>
            );
        }
        //
        let _r = [];
        //
        for (let [_key, _d_items] of bf.e(global.c?.state[pd.state])) { // 現行は、3階層まで
            if (_d_items.b_dlt != true) {
                _r.push(_fnc01(bf.p(_d_items, _next =>{
                    _next.n_lyr = 1;
                    _next.pid = '{}'.f(_key);
                })));
                if (_d_items.clds) {
                    for (let [_cldKey1, _d_cldItems1] of bf.e(_d_items.clds)) {
                        if (_d_cldItems1.b_dlt != true) {
                            _r.push(_fnc01(bf.p(_d_cldItems1, _next => {
                                _next.n_lyr = 2;
                                _next.pid = '{}_{}'.f(_key, _cldKey1);
                            })));
                            if (_d_cldItems1.clds) {
                                for (let [_cldKey2, _d_cldItems2] of bf.e(_d_cldItems1.clds)) {
                                    if (_d_cldItems2.b_dlt != true) {
                                        _r.push(_fnc01(bf.p(_d_cldItems2, _next =>{
                                            _next.n_lyr = 3;
                                            _next.pid = '{}_{}_{}'.f(_key, _cldKey1, _cldKey2);
                                        })));
                                    };
                                };
                            };
                            if (pd.b_edt) {
                                let _d_items3 = {
                                    ini: '',
                                };
                                let _newKey3 = bf.myCM_get_newKey(_d_cldItems1.clds);
                                _r.push(_fnc01(bf.p(_d_items3, _next =>{
                                    _next.n_lyr = 3;
                                    _next.pid = '{}_{}_{}'.f(_key, _cldKey1, _newKey3);
                                })));
                            };
                        };
                    };
                };
                if (pd.b_edt) {
                    let _d_items2 = {
                        ini: '',
                        clds: {},
                    };
                    let _newKey2 = bf.myCM_get_newKey(_d_items.clds);
                    _r.push(_fnc01(bf.p(_d_items2, _next =>{
                        _next.n_lyr = 2;
                        _next.pid = '{}_{}'.f(_key, _newKey2);
                    })));
                };
            };
        };
        if (pd.b_edt) {
            let _d_items2 = {
                ini: '',
                clds: {},
            };
            let _newKey = bf.myCM_get_newKey(global.c?.state[pd.state]);
            _r.push(_fnc01(bf.p(_d_items2, _next =>{
                _next.n_lyr = 1;
                _next.pid = '{}'.f(_newKey);
            })));
        }
        //
        return (
            <View>
                { (pd.b_vsb != false) ?
                    <ScrollView
                        contentContainerStyle={[{
                            flexDirection: 'column',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            borderWidth: 0,
                            margin: 0,
                            padding: 0,
                        }, pd.stlCta]}
                        showsVerticalScrollIndicator={true}
                    >
                        <View
                            key={-1}
                        >
                            <ce.Lbl
                                key={-1}
                                b_vsb={(pd.pfx) ? true : false}
                                
                                pfx={pd.pfx}
                                stlCta={{
                                }}
                                stlPfx={{
                                    fontSize: ic.gn_fontSizeLrg,
                                    color: ic.g_fontCcdLrg,
                                }}
                            />
                            {_r}
                        </View>
                    </ScrollView>
                : null }
            </View>
        );
    }

    static Ldr (pd) { // loader
        //
        return (
            <>
                { (global.c?.state[pd.state]) ?
                    <View
                        style={{
                            position: 'absolute',
                            zIndex: ic.gn_zIdxLdr,
                            top: 0,
                            left: 0,
                            height: '100%',
                            width: '100%',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <View
                            style={{
                                height: 100,
                                width: 100,
                                borderRadius: ic.gn_bdrRdsNrm,
                                backgroundColor: '#eeeeee',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // for border
                                borderWidth: ic.gn_bdrWNrw,
                                borderColor: '#eeeeee',
                            }}
                        >
                            <ActivityIndicator
                               animating = {true}
                               color = {(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd}
                               size = "large"
                            />
                        </View>
                    </View>
                : null }
            </>
        );
    }

  static InpTree2 = (pd={
    b_vsb: true,
    b_edt: true,
    state: [{
      elm: '',
      key: '',
      b_dlt: false, // dlt の状況
      flds: [
        {
          fld: '',
          ini: '',
          val: '', 
          b_uid: false, // uid の有無
          phd: '',
        },
      ],
      b_cls: false, // 子要素の表示状況
      clds: [], // 子要素
    }],    
  }) => { // inputs

    if (pd.b_vsb == false) { // b_vsb == false の場合は非表示
      return null;
    }

    let _r = [];

    let _get_crrElm = (pld_elmTreess, pl_elmIdxs) => { // pld_elmTreess において pl_pntIdxs/pn_elmIdx で指定された elm を取得する
      let _d_elms = null;
      for (let [_n, _elmIdx] of bf.e(pl_elmIdxs)) {
        if (_n == 0) {
          _d_elms = pld_elmTreess[_elmIdx];
        }
        else {
          _d_elms = _d_elms.ld_cldElmss[_elmIdx];
        };
      };
      return _d_elms;
    };

    let _rdr_tree = (pd2={ // render tree
      ld_elmss: [],
      b_hdrPrs: false,
      b_btnPrs: false,
      d_cldElmDefs: {
        b_hdrPrs: false,
        b_btnPrs: false,
        d_cldElmDefs: {},
      },
      l_elmIdxs: [], // set automatically
      n_lyr: 1, // set automatically
    }) => pd2.ld_elmss?.map( (_d_elms, _elmIdx) => { // elm ごとの処理
      if (_d_elms.b_dlt != true) {
        //
        let _n_lyr = pd2.n_lyr || 1;
        //
        let _l_crrElmIdxs = bf.myCM_copy(pd2.l_elmIdxs || []);
        _l_crrElmIdxs.push(_elmIdx);
        //
        let _l_cpts = []; // component
        _l_cpts = _d_elms.ld_fldss?.map( (_d_flds, _fldIdx) => ( // fld ごとの処理
          <ce.Inp
            key={'{}.{}.{}'.f(_d_elms.elm, _d_elms.key, _d_flds.fld)}
            b_vsb={pd.b_vsb}
            b_edt={pd.b_edt}
            state={null}
            d_ids={null}
            ctlVal={_d_flds.ini}
            ini={null}
            pfx={_d_flds.pfx}
            b_mln={pd.b_mln}
            phd={_d_flds.phd}
            onBlur={pd.onBlur}
            onChg={ _s => {
              global.c?.setState({
                [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                  let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                  _d_crrElms.ld_fldss[_fldIdx].val = _s;
                  _d_crrElms.ld_fldss[_fldIdx].b_uid = true;
                }),
              });
            }}
            onFcs={pd.onFcs}
            stlCta={pd.stlCta}
            stlInp={pd.stlInp}
            n_lyr={_n_lyr}
            d_btnDefs={{
              hdrIconName: (_d_elms.b_cls == true) ? 'chevron-right' : 'chevron-down',
              onHdrPrs: 
                (pd2.b_hdrPrs != false) ? 
                  _d_ids => {
                    global.c?.setState({
                      [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                        let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                        _d_crrElms.b_cls = (_d_crrElms.b_cls) ? false : true;
                      }),
                    });
                  }
                : null,
              btnIconName: 'plus',
              onBtnPrs:
                (pd2.b_btnPrs != false) ? 
                  _d_ids => {
                    global.c?.setState({
                      [pd.state] : bf.p(global.c?.state[pd.state], _next => { // 子要素の追加
                        let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                        if (!bf.f(_d_crrElms.ld_cldElmss)) {
                          _d_crrElms.ld_cldElmss = [];
                        };
                        _d_crrElms.ld_cldElmss.push(pd2.o_grtCldElm());
                      }),
                    })
                  }
                : null,
              onDltPrs: _d_ids => { // 本要素の削除
                global.c?.setState({
                  [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                    let _d_crrElms = _get_crrElm(_next, _l_crrElmIdxs);
                    _d_crrElms.b_dlt = true;
                    _d_crrElms.ld_fldss[_fldIdx].b_uid = true;
                  }),
                });
              },
            }}
          />
        ));

        if (bf.f(_d_elms.ld_cldElmss && _d_elms.b_cls != true)) {
          _l_cpts.push(_rdr_tree(bf.p(pd2.d_cldElmDefs, _next => {
            _next.ld_elmss = _d_elms.ld_cldElmss;
            _next.l_elmIdxs = _l_crrElmIdxs;
            _next.n_lyr = _n_lyr + 1;
          })));
        };

        return _l_cpts;
      }
      else {
        return null;
      };
    });

    _r = _rdr_tree(bf.p(pd.d_elmDefss, _next => {
      _next.ld_elmss = global.c?.state[pd.state];
    }));

    return (
      <View
        key={-1}
      >
        <ce.Lbl
          key={-1}
          b_vsb={(pd.pfx) ? true : false}
          pfx={pd.pfx}
          iconName={'plus'}
          onBtnPrs={
            (pd.b_edt) ? 
              () => {
                global.c?.setState({
                  [pd.state] : bf.p(global.c?.state[pd.state], _next => {
                    _next.push(
                      pd.d_elmDefss.o_grtElm(),
                    )
                  }),
                }, () => {
                })
              }
            : null }
          stlCta={{
          }}
          stlPfx={{
              fontSize: ic.gn_fontSizeLrg,
              color: ic.g_fontCcdLrg,
          }}
        />
        {_r}
      </View>
    );
  }

  // mdl は root と同階層で定義する
  // 仮に mdl を bdy 内で定義した場合、bdy 内部のスクロールに合わせて、mdl の表示位置が変わってしまう
  // なお、root の zIdx は bdy の zIdx よらず打ち勝つため、root で定義した overlay を bdy 内の cpt で共有することはできない
  static Mdl(pd){

    if (global.c?.state.sgcd_mdls[pd.mdlType]?.b_showMdl != true) { // sgcd_mdls に mdlType が定義されていない場合、エラーとなる
      return null;
    };

//          }, pd.stlMenu]}
    return (
      <View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: ic.gn_zIdxMdl,
          backgroundColor: 'rgba(0,0,0,0.2)',
          height: ic.gn_h,
          width: ic.gn_w,
        }}
      >
        <View
          style={[{
            backgroundColor: ic.g_ccdWN,
            maxHeight: ic.gn_mdlH,
            width: ic.gn_mdlW,
            borderRadius: ic.gn_bdrRdsNrm,
            marginTop: 'auto',
            marginBottom: 'auto',
            marginLeft: 'auto',
            marginRight: 'auto',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }, pd.stlCta]}
        >
          <ce.BtnIcon
            b_vsb={true}
            iconName="close"
            onPrs={()=>{
              if (pd.onCls) {
                pd.onCls()
              }
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                  _next[pd.mdlType].b_showMdl = false;
                }),
              });
            }}
            stlCta={{
              width: ic.gn_mdlW,
            }}
            stlBtn={{
              backgroundColor: ic.gn_backCcd,
              marginLeft: 'auto',
              marginRight: 0,
            }}
          />
          <View
            style={{
              maxHeight: ic.gn_mdlH - ic.gn_btnIconSize - ic.gn_mgnNrm * 2,
              width: ic.gn_mdlW,
              marginTop: ic.gn_mgnNrm,
              marginBottom: ic.gn_mgnNrm,
              marginLeft: 0,
              marginRight: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }}
          >
            {(pd.children) ? pd.children : global.c?.state.sgco_mdlChd}
          </View>
        </View>
      </View>
    );
  };

    static Link (pd) {
        return (
            <Text
                style={[{
                    fontSize: ic.gn_fontSizeNrm,
                    color: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd,
                    textDecorationLine: 'underline',
                }, pd.stlLink]}
                onPress={async ()=>{
                    if (bf.f(pd.url)) {
                        cf.myRN_open_url(pd.url);
                    };
                    if (bf.f(pd.file)) {
                        if (!cf.myRN_chk_os('w')) {
                            let _fdr = await cf.myFS_get_rootFdr();
                            await cf.myFS_make_fdr(_fdr);                                    
                            let _name = _fdr + pd.file.name;
                            cf.myFS_open_url(pd.file.url, _name); // FileSystem は WEB に対応していない。サーバー側でファイル名の変更が必要か
                        }
                        else {
                            cf.myRN_open_url(pd.file.url);
                            //Sharing.shareAsync(pd.file.url) // https 化すれば動く模様
                        }
                    };                    
                    if (pd.onPrs) {
                        pd.onPrs();
                    };
                }}
            >
                {pd.children}
            </Text>
        )
    }

    static Mp4 (pd) {
        //
        let _r = [];

        let _o_video = null;
        //
        return (
            <>
                { (pd.b_vsb != false) ?
                    <View>
                        { (pd.pfx) ?
                            <View
                                style={{
                                    width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                    marginTop: ic.gn_mgnNrm,
                                    marginBottom: ic.gn_mgnNrm,
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }}
                            >
                                <Text 
                                    style={ [{
                                        fontSize: ic.gn_fontSizeSml,
                                        color: ic.g_fontCcdSml,
                                        paddingTop: ic.gn_mgnNrm,
                                        paddingBottom: ic.gn_mgnNrm,
                                        paddingLeft: 0,
                                        paddingRight: 0,
                                        fontWeight: 'bold',
                                    }, pd.stlPfx] }
                                >
                                    { pd.pfx }
                                </Text>
                            </View>
                        : null }
                        <View
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <View
                                style={[{
                                    height: (((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW) / (16/9),
                                    width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                    marginTop: ic.gn_mgnNrm,
                                    marginBottom: ic.gn_mgnNrm,
                                    marginLeft: 'auto',
                                    marginRight: 'auto',
                                }, pd.stlCta]}
                            >
                                <TouchableOpacity
                                    activeOpacity={0.0}
                                    onPress={()=>{
                                        if (pd.b_edt == true) { // 編集モードの場合
                                            cf.myIP_pick_img((_d_items) => {
                                                if ( global.c != null && pd.state != null ) {
                                                    global.c?.setState({[pd.state]:String(_d_items.uri)})
                                                };
                                                if (pd.onPrs) {
                                                    pd.onPrs(_d_items); // {height:, duration:, uri:, type:, width:}
                                                };
                                            }, 'video');                        
                                        };                                        
                                        if (pd.b_edt == false) {
                                            _o_video.getStatusAsync().then((_res)=>{
                                                if (_res.shouldPlay == false) { // 最初から再生
                                                    _o_video.setStatusAsync({
                                                        positionMillis: 0,
                                                        shouldPlay: true
                                                    });
                                                };
                                            });
                                        };
                                    }}
                                >

                                    { ((global.c != null && pd.state != null && cf.b(global.c?.state[pd.state]) == false) || (!bf.f(pd.uri) == false)) ?

                                        <Video
                                            source={{ uri: (global.c != null && pd.state != null && cf.b(global.c?.state[pd.state]) == false) ? global.c?.state[pd.state] : String(pd.uri)}}
                                            rate={1.0}
                                            volume={1.0}
                                            isMuted={true}
                                            resizeMode={Video.RESIZE_MODE_CONTAIN}
                                            shouldPlay={false}
                                            useNativeControls={true}
                                            isLooping={false}
                                            usePoster={true}
                                            ref = {(_o) => {
                                                _o_video = _o;
                                            }}
                                            style={{ 
                                                height: (((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW) / (16/9),
                                                width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                            }}
                                        />
                                    :
                                        <View
                                            style={{
                                                height: '100%',
                                                width: '100%',
                                                backgroundColor: ic.g_ccdHP,
                                                borderRadius: ic.gn_bdrRdsNrm,
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Text
                                                style={{
                                                    fontSize: ic.gn_fontSizeNrm,
                                                    color: ic.g_ccdWN,
                                                }}
                                            >
                                                {pd.msg}
                                            </Text>
                                        </View>
                                    }
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                : null }
            </>
        );
    }

    static Msg = (pd={
      b_vsb: true,
      pfx: '',
      n_pntW: 0,
      stlCta: {},
      stlPfx: {},
    }) => {
      if (pd.b_vsb == false) {
        return null;
      };

      return (
        <View style={[{
          width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2,
          marginLeft: 'auto',
          marginRight: 'auto',
          marginTop: ic.gn_mgnLrg,
          marginBottom: ic.gn_mgnLrg,
          paddingStart: 0,
          paddingEnd: 0,
          paddingTop: 0,
          paddingBottom: 0,
        }, pd.stlCta]}>
          <Text
            style={[{
              fontSize: ic.gn_fontSizeNrm,
              color: ic.g_fontCcdNrm,
            }, pd.stlPfx]}
          >
            { pd.pfx }
          </Text>
        </View>
      );
    }

  static Pck(pd) {
    //
/*
        o_rlcFldPrs={(pd.o_rlcFldPrs) ? () => {
//bf.l('4514: {}'.f(pd.d_ids))
          pd.o_rlcFldPrs(pd.d_ids);
        } : null}
 */
/*
bf.l('4593: {}, {}, {}'.f(
(bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini})) ? bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}).pfx : 'no data',
pd.ini,
bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini})
))
*/
    return (
      <ce._fld
        key={-1}
        b_vsb={pd.b_vsb}
        b_edt={pd.b_edt}
        state={pd.state}
        pfx={pd.pfx}
        ini={(
          pd.ld_itemss && 
          pd.ini && 
          bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}) 
        ) ? bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}).pfx 
          : null
        }
        d_ids={pd.d_ids}
        ctlVal={pd.ctlVal}
        phd={(pd.phd) ? pd.phd : ((pd.b_edt) ? '選択ください' : '')}
        phdCcd={pd.phdCcd}
        mdlType={'pck'}
        ld_itemss={pd.ld_itemss}
        b_newLine={pd.b_newLine || false}
        o_rlcFldPrs={(pd.o_rlcFldPrs) ? () => {
          pd.o_rlcFldPrs(pd.d_ids);
        } : null}
        onFldPrs={() => {
          global.c?.setState({
            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
              _next.pck.ld_itemss = pd.ld_itemss.filter(_d_is => (_d_is.b_hide != true) ? true : false); // b_hide == true は list 表示の対象外
            }),
          }, ()=>{
          });
        }}
        onDltPrs={(pd.state) ? pd.onDltPrs : pd.onDltPrsAsCld}
        onChg={(_d_items) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
//bf.l('4588: {}'.f(_d_items));
          if (pd.state) { // clds でない場合
//bf.l('4590: here');
            global.c?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
              [pd.state]: _d_items.key,
            }, ()=>{
              if (pd.onChg) pd.onChg(_d_items);
            });
          }
          else { // clds の場合
/*
            if(pd.onChg){
              pd.onChg(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
            }
*/
//bf.l('4603: {}, {}, {}'.f(_d_items, pd.d_ids, pd.prtKey));
            if (pd.onChgAsCld) pd.onChgAsCld(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
          };
        }}
        stlCta={pd.stlCta}
        stlPfx={pd.stlPfx}
        n_col={pd.n_col}
        stlLbl={pd.stlLbl}
      />
    );
  };

  static PckMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

    let _r = [];

    for (let [_idx, _d_items] of bf.e(global.c?.state.sgcd_mdls.pck.ld_itemss)) {

      if (_d_items.b_dlt == true) { // b_dlt が true である item は表示対象外
        continue;
      };

      _r.push(
        <TouchableOpacity
          key={_idx}
          onPress={()=>{
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next['pck'].d_slcItems = _d_items;
                _next['pck'].b_showMdl = false;
              }),
            }, ()=>{
            });
          }}
        >
          <View style={[{
            width: ic.gn_mdlW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }, _d_items.stlCta]}>
            <Text
              style={{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              }}
            >
              {_d_items.pfx}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <ce.Mdl
        key={-1}
        mdlType={'pck'}
      >
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
          {_r}
        </ScrollView>
      </ce.Mdl>
    );
  };

/*
  static PckSlc(pd) { // 指定された分類で絞り込んだ上で選択
    //
    return (
      <ce._fld
        key={-1}
        b_vsb={pd.b_vsb}
        b_edt={pd.b_edt}
        state={pd.state}
        pfx={pd.pfx}
        ini={(
          pd.ld_itemss && 
          pd.ini && 
          bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}) 
        ) ? bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}).pfx 
          : null
        }
        d_ids={pd.d_ids}
        ctlVal={pd.ctlVal}
        phd={(pd.phd) ? pd.phd : ((pd.b_edt) ? '選択ください' : '')}
        phdCcd={pd.phdCcd}
        mdlType={'pckSlc'}
        ld_itemss={pd.ld_itemss}
        b_newLine={false}
        onFldPrs={() => {
          global.c?.setState({
            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
              _next['pckSlc'].ld_itemss = pd.ld_itemss.filter(_d_is => (_d_is.b_show != false) ? true : false); // b_hide == true は list 表示の対象外
            }),
          }, ()=>{
          });
        }}
        onDltPrs={pd.onDltPrs}
        onChg={(_d_items) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
          if (pd.state) { // clds でない場合
            global.c?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
              [pd.state]: _d_items.key,
            }, ()=>{
              if(pd.onChg){
                pd.onChg(_d_items);
              };
            });
          }
          else { // clds の場合
            if(pd.onChg){
              pd.onChg(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
            }
          };
        }}
        stlCta={pd.stlCta}
        stlPfx={pd.stlPfx}
        n_col={pd.n_col}
        stlLbl={pd.stlLbl}
      />
    );
  };

  static PckSlcMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

    let _r = [];

    const [_s_ctg, _setCtg] = useState('全件');
    const [_sld_iss, _setIss] = useState([]);
    useEffect(()=> {
      let _ld_iss = global.c?.state.sgcd_mdls.pckSlc.ld_itemss
      .filter( _d_is => (_s_ctg == '全件' || _d_is.ctg == _s_ctg) ? true : false);
      _setIss(_ld_iss);
    }, [
      global.c?.state.sgcd_mdls.pckSlc.ld_itemss,
      _s_ctg
    ]);

    let _ld_iss1 = bf.c(
      [{key:'全件', pfx:'全件'}], 
      global.c?.state.sgcd_mdls.pckSlc.ld_itemss
      .map( _d_is => _d_is.ctg )
      .reduce( (_prev, _ctg) => {
        if (_prev.includes(_ctg) == false) {
          _prev.push(_ctg)
        };
        return _prev;
      }, [])
      .map( _ctg => ({ key:_ctg, pfx:_ctg }))
    );

    _r.push(
      <ce._fld
        key={-1}
        b_vsb={true}
        b_edt={true}
        state={null}
        pfx={null}
        ini={_s_ctg}
        d_ids={null}
        ctlVal={null}
        phd={'選択ください'}
        phdCcd={null}
        mdlType={'pck'}
        ld_itemss={_ld_iss1}
        b_newLine={false}
        onFldPrs={() => {
          global.c?.setState({
            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
              _next['pck'].ld_itemss = _ld_iss1; // b_hide == true は list 表示の対象外
            }),
          }, ()=>{
          });
        }}
        onDltPrs={null}
        onChg={(_d_is) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
          _setCtg(_d_is.key);
        }}
      />
    );

    for (let [_idx, _d_is] of bf.e(_sld_iss)) {

      if (_d_is.b_dlt == true) { // b_dlt が true である item は表示対象外
        continue;
      };

      _r.push(
        <TouchableOpacity
          key={_idx}
          onPress={()=>{
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next['pckSlc'].d_slcItems = _d_is;
                _next['pckSlc'].b_showMdl = false;
              }),
            }, ()=>{
            });
          }}
        >
          <View style={[{
            width: ic.gn_mdlW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }, _d_is.stlCta]}>
            <Text
              style={{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              }}
            >
              {_d_is.pfx}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <ce.Mdl
        key={-1}
        mdlType={'pckSlc'}
        stlCta={{
          height: '80%',
        }}
      >
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
          {_r}
        </ScrollView>
      </ce.Mdl>
    );
  };
*/
  static PckSlc(pd) { // 指定された分類で絞り込んだ上で選択

    // pck 用の識別番号
    const _pckId = 'pckId20210625';
    //
    // 分類の更新
    let _ld_itemss = pd.ld_itemss
    .filter(_d_is => (_d_is.b_show != false) ? true : false )
    .map( (_d_is, _idx) => ({idx: _idx, ..._d_is})) // sort のため deep copy

    let _ld_ctgss = bf.c(
      pd.ld_itemss
      .filter(_d_is => (_d_is.b_show != false) ? true : false )
      .map( (_d_is, _idx) => ({idx: _idx, ..._d_is})) // sort は破壊的なため deep copy
      .sort( (_d_is1, _d_is2) => {
        if ((_d_is1.n_ctgOdr || 0) > (_d_is2.n_ctgOdr || 0)) return 1;
        if ((_d_is1.n_ctgOdr || 0) < (_d_is2.n_ctgOdr || 0)) return -1;
        return 0;
      })
      .map( _d_is => _d_is.ctg )
      .reduce( (_prev, _ctg) => {
        if (_prev.includes(_ctg) == false) {
          _prev.push(_ctg)
        };
        return _prev;
      }, [])
      .map( _ctg => ({ key:_ctg, pfx:_ctg })),
      [{key:'全分類', pfx:'全ての分類'}], 
    );
    //
/*
bf.l('4960: {}, {}, {}, {}'.f(
  global.c?.state.sgcd_pageCmns?.cm20_key,
  pd.ctlVal,
  pd.ini,
  (bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini})) ? bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}).pfx : ''
))
*/
    return (
      <ce._fld
        key={-1}
        b_vsb={pd.b_vsb}
        b_edt={pd.b_edt}
        state={pd.state}
        pfx={pd.pfx}
        ini={(
          pd.ld_itemss && 
          pd.ini && 
          bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}) 
        ) ? bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ini}).pfx 
          : null
        }
        d_ids={pd.d_ids}
        ctlVal={pd.ctlVal}
        phd={(pd.phd) ? pd.phd : ((pd.b_edt) ? '選択ください' : '')}
        phdCcd={pd.phdCcd}
        mdlType={'pckSlc'}
        ld_itemss={pd.ld_itemss}
        b_newLine={false}
        onFldPrs={() => {
          global.c?.setState({
            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
              _next['pck'].id = _pckId;
              _next['pck'].ld_itemss = _ld_ctgss; // b_hide == true は list 表示の対象外
              _next['pck'].b_showMdl = true;
              _next['pckSlc'].ld_itemss = pd.ld_itemss.filter(_d_is => (_d_is.b_hide != true) ? true : false); // b_hide == true は list 表示の対象外
            }),
          }, ()=>{
          });
        }}
        onDltPrs={pd.onDltPrs}
        onChg={(_d_items) => { // pck の場合、mdl で処理するため、onBlur が意味をなさないことに注意
          if (pd.state) { // clds でない場合
            global.c?.setState({ // clds でない場合は onChg において state に反映されて、clds の場合は 
              [pd.state]: _d_items.key,
            }, ()=>{
              if(pd.onChg){
                pd.onChg(_d_items);
              };
            });
          }
          else { // clds の場合
            if(pd.onChgAsCld){
              pd.onChgAsCld(_d_items, pd.d_ids); // clds の二重登録を防ぐために itemKey が必要
            }
          };
        }}
        stlCta={pd.stlCta}
        stlPfx={pd.stlPfx}
        n_col={pd.n_col}
        stlLbl={pd.stlLbl}
      />
    );
  };

  static PckSlcMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

    // pck 用の識別番号
    const _pckId = 'pckId20210625';

    let _r = [];

    const [_sld_iss, _setIss] = useState([]);
    useEffect(()=> {
      if ( global.c?.state.sgcd_mdls['pck'].id == _pckId ) {
        let _ctg = global.c?.state.sgcd_mdls['pck'].d_slcItems.key || '全分類';
        let _ld_iss = bf.c(
          global.c?.state.sgcd_mdls.pckSlc.ld_itemss
            .filter( _d_is => ( _ctg == '全分類' || _d_is.ctg == _ctg ) ? true : false),
          [{key: '戻る', pfx: '戻る'}]
        );
        _setIss(_ld_iss);
      };
    }, [
      global.c?.state.sgcd_mdls.pckSlc.ld_itemss,
      global.c?.state.sgcd_mdls['pck'].d_slcItems
    ]);

    for (let [_idx, _d_is] of bf.e(_sld_iss)) {

      if (_d_is.b_dlt == true) { // b_dlt が true である item は表示対象外
        continue;
      };

      _r.push(
        <TouchableOpacity
          key={_idx}
          onPress={()=>{
            if ( _d_is.key == '戻る' ) { // 戻る の場合
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                  _next['pck'].id = _pckId;
                  _next['pck'].b_showMdl = true;
                }),
              }, ()=>{
              });
            }
            else {
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                  _next['pckSlc'].d_slcItems = _d_is;
                  _next['pckSlc'].b_showMdl = false;
                }),
              }, ()=>{
              });
            };
          }}
        >
          <View style={[{
            width: ic.gn_mdlW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }, _d_is.stlCta]}>
            <Text
              style={{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              }}
            >
              {_d_is.pfx}
            </Text>
          </View>
        </TouchableOpacity>
      );
    };

    return (
      <ce.Mdl
        key={-1}
        mdlType={'pckSlc'}
      >
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
          {_r}
        </ScrollView>
      </ce.Mdl>
    );
  };

  static MenuMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理

    let _r = global.c?.state.sgcd_mdls.menu.ld_iss.map( (_d_is, _idx) => {
      return (
        <TouchableOpacity
          key={_idx}
          onPress={()=>{
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next.menu.b_showMdl = false;
              }),
            }, ()=>{
              if (_d_is.onPrs) {
                _d_is.onPrs();
              };
            });
          }}
        >
          <View style={{
            width: ic.gn_mdlW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
            marginTop: ic.gn_mgnNrm,
            marginBottom: ic.gn_mgnNrm,
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingTop: ic.gn_mgnNrm,
            paddingBottom: ic.gn_mgnNrm,
            paddingLeft: ic.gn_mgnNrm,
            paddingRight: ic.gn_mgnNrm,
            borderWidth: ic.gn_bdrWNrw * 1.5,
            borderColor: '#bbbbbb',
            borderRadius: ic.gn_bdrRdsNrm,
          }}>
            <Text
              style={{
                fontSize: ic.gn_fontSizeNrm,
                color: ic.g_fontCcdNrm,
                textAlign: 'center',
              }}
            >
              {_d_is.pfx}
            </Text>
          </View>
        </TouchableOpacity>
      );
    });

    return (
      <ce.Mdl
        key={-1}
        mdlType={'menu'}
      >
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
          {_r}
        </ScrollView>
      </ce.Mdl>
    );
  };

  static MsgMdl(pd) { // 選択された項目を d_slcItems に反映し、_fld で処理
    return (
      <ce.Mdl
        key={-1}
        mdlType={'msg'}
      >
        <ce.Msg
          pfx={pd.d_msgs?.pfx}
          stlCta={bf.c({
            marginLeft: ic.gn_mgnNrm,
            marginRight: ic.gn_mgnNrm,
          }, pd.d_msgs?.stlCta)}
          stlPfx={pd.d_msgs?.stlPfx}
        />
        <ce.Btn
          pfx={'閉じる'}
          onPrs={()=>{
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next.msg.b_showMdl = false;
              }),
            });
          }}
        />
      </ce.Mdl>
    );
  };

/*
            stlCta={{
              marginLeft: ic.gn_mgnNrm,
              marginRight: ic.gn_mgnNrm,
            }}
            stlCta={{
              height: ic.gn_mgnNrm * 2 + ic.gn_fontSizeNrm,
              marginLeft: ic.gn_mngnNrm,
              marginRight: ic.gn_mngnNrm,
            }}
            stlBtn={{
              height: ic.gn_mgnNrm * 2 + ic.gn_fontSizeNrm,
              marginLeft: ic.gn_mngnNrm,
              marginRight: ic.gn_mngnNrm,
            }}
            stlCta={{
              width: ic.gn_mdlW - (ic.gn_mngnNrm * 2 + ic.gn_scbW),
              marginLeft: ic.gn_mngnNrm,
              marginRight: ic.gn_mngnNrm,
            }}
        <ScrollView
          key={-1}
          showsVerticalScrollIndicator={true}
        >
        </ScrollView>
*/

  static FileMdl(pd) { // File Inport 用のモーダル
    return (
      <ce.Mdl
        key={-1}
        mdlType={'file'}
      >
        <RNDropzone
          key={-1}
          onDrop={ _lo_files => {
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next.file.b_showMdl = false;
              }),
            }, () => {
              _lo_files.map(_o_file => {
                bf.myFL_read({
                  mode: global.c?.state.sgcd_mdls?.file?.mode, 
                  o_file: _o_file
                })
                .then( _r => {
//alert('4314:{}'.f(_r))
                  if (global.c?.state.sgcd_mdls?.file?.onRead) {
                    global.c?.state.sgcd_mdls.file.onRead(_r);
                  };
                });
              });
            });
          }}
          multiple={true}
        >
          {({ getRootProps, getInputProps }) => {
            return (
              <div
                {...getRootProps()}
                style={{
                  height: ic.gn_fontSizeNrm * 5 + ic.gn_mgnNrm * 2,
                  width: ic.gn_mdlW - ic.gn_mgnNrm * 3,
                  borderWidth: ic.gn_bdrWNrm,
                  borderStyle: 'dashed',
                  borderColor: '#E0E0E0',
                  marginTop: ic.gn_mgnNrm,
                  marginBottom: ic.gn_mgnNrm,
                  marginLeft: ic.gn_mgnNrm,
                  marginRight: ic.gn_mgnNrm,
                  paddingTop: 'auto',
                  paddingBottom: 'auto',
                  paddingLeft: 'auto',
                  paddingRight: 'auto',
                  flexDirecton: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <input
                  {...getInputProps()}
                />
                <p>click or drop files here</p>
              </div>
            );
          }}
        </RNDropzone>
      </ce.Mdl>
    );
  };
/*
          accept={'**'}
 */

    static Qr(pd) {
        if (pd.b_vsb == false || !bf.f(pd.val)) {
            return null;
        };
        
        return (
            <>
                <ce.Lbl
                    key={-1}                    
                    pfx={pd.pfx}
                />
                <View
                    key={-2}   
                    style={{
                        width: ic.gn_bdyW - ic.gn_mgn_Nrm * 2 - ic.gn_scbW,
                        marginLeft: 'auto',
                        marginRight: 'auto',                    
                    }}
                >
                    <QRCode
                        key={-1}
                        value={pd.val}
                    />
                </View>
            </>
        );
    };

    static _fld(pd) { // pd.ini か d_slcItems が設定された場合に値が変更される

        let _r = [];

        const [_s_id, _setId] = useState('');
        const [_s_val, _setVal] = useState(pd.ini || ''); // 前回の値が初期表示されないよう pd.ini が null の場合は '' で初期化

        useEffect(()=>{ // _s_id ではなく do_fnc を用いることで処理を効率化できないか
          let _d_slcItems = global.c?.state.sgcd_mdls[pd.mdlType]?.d_slcItems;
          if (bf.f(_d_slcItems)) {
            if (_d_slcItems.key != '') {
//bf.l('5451:{}, {}, {}'.f(global.c?.state.sgcd_mdls[pd.mdlType].id, _s_id, _d_slcItems.key))
//              if (global.c?.state.sgcd_mdls[pd.mdlType].id == _s_id) { // 同一 id の場合（ id はボタン押下時に発行 ） ※重複する key がある場合、全てに値が反映されるため
              if (
                bf.f(global.c?.state.sgcd_mdls[pd.mdlType].id) && 
                bf.f(_s_id) && 
                global.c?.state.sgcd_mdls[pd.mdlType].id == _s_id
              ) { // 同一 id の場合（ id はボタン押下時に発行 ） ※重複する key がある場合、全てに値が反映されるため
                if (pd.b_newLine == true) { // b_newLine である新規登録行は反映しない
//bf.l('5242: {}'.f(pd.b_newLine))
                  _setVal('');
                }
                else {
//bf.l('5246: {}'.f(pd.b_newLine))
                  if (pd.state) { // clds でない場合
                    global.c?.setState({
                      [pd.state]: _d_slcItems.key,
                    }, () => {
                    });
                  }
                  else { // clds の場合
//bf.l('5254: here'.f(_d_slcItems.pfx))
                    _setVal(_d_slcItems.pfx);
                  };
                };
                //
//bf.l('5245: here')
                if(pd.onChg) { // clds の場合、値を反映
//bf.l('5241: {}'.f(_d_slcItems))
//bf.l('5247: here')
                  global.c?.setState({ // 同一要素を繰り返し選択可能とするためには d_slcItems の初期化が必要
                    sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                      _next[pd.mdlType].d_slcItems = {};
                    }),
                  }, () => {
//bf.l('5253: {}'.f(pd.onChg))
                    pd.onChg(_d_slcItems);
                  });
                };
              };
            };
          };
        }, [
          global.c?.state.sgcd_mdls[pd.mdlType]?.d_slcItems
        ]) // 同一id かつ b_newLine 以外で d_slcItems が設定された場合に値が変更される

        useEffect(()=>{ 
//bf.l('5483:here')
          if (
            bf.f(pd.state) && 
            bf.f(global.c?.state[pd.state]) && 
            bf.f(pd.ld_itemss)
          ) {
            if (
              bf.f(bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:global.c?.state[pd.state]}))
            ) { // pd.ld_itemss に対応する値が存在する場合
              _setVal(bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:global.c?.state[pd.state]}).pfx);
            }
            else { // pd.ld_items に対応する値が存在しない場合
//bf.l('5282: {}'.f(pd.state))
              _setVal('');
            };
          };
        }, [
          global.c?.state[pd.state], 
          pd.ld_itemss
        ]);

        useEffect(()=>{ 
//bf.l('5503:here')
          if (pd.ctlVal){
/*
            if (bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ctlVal})) {
              _setVal(bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ctlVal}).pfx);
            };
*/
//            let _val1 = bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ctlVal});
//            let _val2 = bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:bf.n(pd.ctlVal)});
//bf.l('5428: {}, {}, {}, {}'.f(pd.ctlVal, _val1, _val2, pd.ld_itemss));
            if (
              bf.f(bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ctlVal}))
            ) { // pd.ld_itemss に対応する値が存在する場合
              _setVal(bf.myCM_get_dct({ld_itemss:pd.ld_itemss, fld:'key', val:pd.ctlVal}).pfx);
            }
            else { // pd.ld_items に対応する値が存在しない場合
              _setVal('');
            };
          };
        }, [pd.ctlVal, pd.ld_itemss]); // pd.dd_listItems が変更された場合に初期値が反映される状況

        if (pd.b_vsb == false) {
            return null;
        };

        return (
          <View
            key={-1}
            style={{
              width: (pd.n_col) ? (pd.n_col * ic.gn_fontSizeNrm) : ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
              maxWidth: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
//              marginTop: ic.gn_mgnNrm,
              marginBottom: ic.gn_mgnNrm,
              marginTop: 0,
//              marginBottom: 0,
              marginLeft: (pd.n_col) ? ic.gn_mgnNrm : 'auto',
              marginRight: (pd.n_col) ? 0 : 'auto',
            }}
          >
            { (pd.pfx) ?
              <ce.Lbl
                key={-1}
                pfx={pd.pfx}
                stlPfx={pd.stlLbl}
              />
            : null }
            <TouchableOpacity
              key={-2}
              onPress={ async ()=>{
                if (pd.b_edt) {
                  if (pd.o_rlcFldPrs){
                    pd.o_rlcFldPrs();
                  }
                  else {
                    if (pd.onFldPrs){
                      await pd.onFldPrs(); // await しないと選択項目が表示されない
                    }
                    global.c?.setState({
                      sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                        let _id = bf.myCM_gnr(10);
                        _setId(_id);
                        _next[pd.mdlType].id = _id;
                        _next[pd.mdlType].b_showMdl = true;
                      }),
                    });
                  };
                }
              }}
            >
              <View
                key={-1}
                style={[{
                  minHeight: ic.gn_fontSizeNrm + ic.gn_mgnNrm * 2 + ic.gn_mgnNrm * 2,
                  paddingTop: ic.gn_mgnNrm,
                  paddingBottom: ic.gn_mgnNrm,
                  paddingLeft: ic.gn_mgnNrm,
                  paddingRight: ic.gn_mgnNrm,
                  borderWidth: ic.gn_bdrWNrw * 1.5,
                  borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                  borderRadius: ic.gn_bdrRdsNrm,
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                }, pd.stlCta]}
              >
                <TextInput
                  key={-1}
                  editable={false}
                  multiline={false}
                  placeholder={pd.phd}
                  placeholderTextColor={pd.phdCcd}
                  value={(_s_val) ? _s_val : ''}
                  style={[{
                    width: '100%',
                    fontSize: ic.gn_fontSizeNrm,
                    color: ic.gn_fontCcdNrm,
                    opacity: 1,
                  }, pd.stlPfx]}
                  disabledInputStyle={{
                    color: ic.gn_fontCcdNrm,
                    opacity: 1,
                  }}
                />
              </View>
            </TouchableOpacity>
            { (pd.onDltPrs) ?
              <ce.BtnIcon
                key={-3}
                b_vsb={pd.b_edt}
                iconName="trash"
                onPrs={()=>{
                  if (pd.onDltPrs) {
                    pd.onDltPrs(pd.d_ids);
                  };
                }}
                stlCta={{
                  position: 'absolute',
                  top: ic.gn_mgnNrm,
                  right: ic.gn_mgnNrm,
                  backgroundColor: ic.gn_backCcd,
                }}
              />
            : null }
          </View>
        );
    };

    static PckDate(pd){
        return (
            <ce._fld
                key={-1}
                b_vsb={pd.b_vsb}
                b_edt={pd.b_edt}
                
                pfx={pd.pfx}
                val={global.c?.state[pd.state]}
                o_mdlChd={(
                    <View
                        key={1}
                        style={{
                            height: ic.gn_mdlH / 2 + ic.gn_mgnLrg * 2,
                        }}
                    >
                        <View
                            key={1}
                            style={{
                                height: ic.gn_mdlH / 2 - ic.gn_mgnLrg * 2,
                            }}
                        >
                            <Calendar
                                key={1}
                                monthFormat={'yyyy年　MM月'}
                                markedDates={(bf.f(global.c?.state[pd.state])) ? {[global.c?.state[pd.state]] : {selected: true, selectedColor: ''}} : null}
                                renderArrow={ _drc => {
                                    if(_drc === 'left') {
                                        return (
                                            <Icon type="FontAwesome5" name="arrow-left" />
                                        );
                                    }
                                    else {
                                        return (
                                            <Icon type="FontAwesome5" name="arrow-right" />
                                        );
                                    }
                                }}
                                onDayPress={(_d_dates) => {
                                    if (global.c?.state[pd.state] != _d_dates.dateString) { // 値が変更されている場合のみ実行
                                        global.c?.setState({
                                            [pd.state]: _d_dates.dateString,
                                        }, ()=>{
                                            if(pd.onChg){
                                                pd.onChg(_d_dates.dateString);
                                            }
                                        });
                                    };
                                    //
                                    global.c?.setState({
                                        sgcb_showMdl: false,
                                    });
                                }}
                            />
                        </View>
                    </View>
                )}
            />
        );
    };
    
    static ListRdb (pd) { // radio button
        //
        let _r = [];
        //
        bf.myCM_for_each(pd.ld_itemss, (_d_items) => {
            _r.push(
                <>
                    <Text
                        style={{
                            width: ic.gn_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                            marginStart: 'auto',
                            marginEnd: 'auto',
                        }}
                    >
                        {_d_items.pfx}
                    </Text>
                    <ce.Rdb
                        
                        state={_d_items.state}
                        ld_itemss={ic.gld_yesNo}
                    />
                </>
            );
        });
        //
        return (
            <>
                {_r}
            </>
        );
    }
    
    static Rdb (pd) { // radio button
        //
        let _r = [];
        //
        bf.myCM_for_each(pd.ld_itemss, (_d_items) => {
            _r.push(
                <>
                    <RadioButton
                        value={_d_items.key}
                        status={ global.c?.state[pd.state] == _d_items.key ? 'checked' : 'unchecked' }
                        onPress={() => {
                            global.c?.setState({
                                [pd.state]: _d_items.key,
                            });
                        }}
                    />
                    <Text>{_d_items.pfx}</Text>
                </>
            );
        });
        //
        return (
            <ce.Row
                stlCta={[{
                    width: ic.gn_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    marginStart: 'auto',
                    marginEnd: 'auto',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }, pd.stlCta]}
            >
                {_r}
            </ce.Row>
        );
    }

    static Rfr (pd) { // referer
        //
        const [_s_crrTextInp, _setTextInp] = useState('');
        //
        useEffect(()=>{
            if (global.c?.state[pd.state]) {
                if (pd.onChgKey){
                    pd.onChgKey(global.c?.state[pd.state])
                    .then((_s)=>{
                        _setTextInp(_s);
                    });
                };
            };
        }, [global.c?.state[pd.state]]);
        //
        return (
            <View 
                style={ [{
                    width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    margin: ic.gn_mgnNrm,
                }, pd.stlCta] }
            >
                <ce.Lbl
                    key={-1} 
                    pfx={pd.pfx}
                />
                <TextInput 
                    key={-2} 
                    editable={pd.b_edt}
                    multiline={false}
                    placeholder={pd.phd}
                    style={ [{
                        color: ic.g_fontCcdNrm,
                        fontSize: ic.gn_fontSizeNrm,
                        borderWidth: ic.gn_bdrWNrw * 1.5,
                        borderColor: (pd.b_edt == true) ? ic.g_bdrCcd : ic.g_ccdWN,
                        borderRadius: ic.gn_bdrRdsNrm,
                        paddingTop: ic.gn_mgnNrm,
                        paddingBottom: ic.gn_mgnNrm,
                        paddingLeft: ic.gn_mgnNrm,
                        paddingRight: ic.gn_mgnNrm,
                        borderRadius: (pd.b_bdr) ? ic.gn_bdrRdsNrm : 0,
                        minHeight: ic.gn_fontSizeNrm * 3,
                    }, pd.stlInp] }
                    value={_s_crrTextInp}
                    onChangeText={(_newTextInp)=>{
                        if (pd.onChgStr) {
                            pd.onChgStr(_newTextInp, _s_crrTextInp);
                        };
                        _setTextInp(_newTextInp);
                    }}
                />
            </View>
        );
    }

    static PckFilesMdl(pd){
        return (
            <ce.Mdl
                key={-1}
                b_vsb={global.c?.state.sgcd_mdls.pckFiles.b_showMdl}
                
                mdlType={'pckFiles'}
            >
                <ce.Files
                    key={-1}
                    
                    b_vsb={true}
                    b_edt={true}
                    pfx='添付ファイル'
                    state='sld_filess'
                    n_pntW={ic.gn_mdlW}
                />
                <ce.Btn
                    key={-2}
                    b_vsb={(bf.myCM_get_len(global.c?.state.sld_filess)>0) ? true : false}
                    b_rvs={false}
                    pfx='送る'
                    onCls={()=>{
                        global.c?.setState({
                            sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                                _next.pckFiles.b_showMdl = false;
                            }),
                        });
                    }}
                    onPrs={()=>{
                        //
                        cf.myRN_ldr_show(global.c); // ldr の表示
                        //
                        // 幹となるメッセージの追加
                        bf.myCM_for_each(global.c?.state.sld_filess, (_d_files)=>{
                            let _d_vals = {
                                ct20b11k: global.c?.state.sgcd_pageCmns?.cm10_key, // お客様 am1d_key
                                ct20cy20: global.c?.state.sgcd_pageCmns?.cm10_key, // 送信者 am1d_key
                                ct20012p: global.c?.state.sgc_user_pfx, // 送信者名
                                ct20012a: cf.myRN_get_uri(global.c?.state.sgc_user_img), // 送信者画像
                                ct20c110: '', // 送信番号
                                ct20c410: '20', // 送信区分：ファイル
                                ct20c610: _d_files.name, // 送信内容
                                ct20cy10: bf.myDT_get_now(),
                            }
                            cf.myCB_call_iud('ins', 'ct20', _d_vals, '')
                            .then((_d_ct20s)=>{
                                // ct10 形式に変更要
                                let _d_vals = {
                                    at3d0110: global.c?.state.sgcd_pageCmns?.cm10_key, // お客さま am1d_key
                                    at3d0120: global.c?.state.sgcd_pageCmns?.cm10_key,   // 登録者 am1d_key
                                    at3d012p: global.c?.state.user_pfx,       // 登録者名
                                    at3d012a: global.c?.state.user_img,       // 登録者画像
                                    ct10l11k: _d_ct20s._KEY,                // リンク先メッセージ ct20_key
                                    at3d013p: 'メッセージの添付ファイル',       // リンク先表記：固定文言
                                    at3d0710: '10',                         // リンク先区分：メッセージ
                                    at3d1010: '',                           // ファイル番号：自動
                                    at3d1010: _d_files.name,                // ファイル表記
                                    ct10c610: '',                           // ファイル
                                    at3d3110: '0',                          // DROPBOX反映状況：未反映
                                    at3d3210: '',                           // DROPBOX反映日時
                                    at3dz830: '0',                          // 削除区分：未削除
                                    at3dz920: bf.myDT_get_now(),            // 登録日時：現在日時
                                };
                                cf.myCB_call_iud('ins', 'at3d', _d_vals, '')
                                .then((_d_at3ds)=>{
                                    cf.myCB_call_upl('at3d', 'ct10c610', _d_at3ds._KEY, _d_files);
                                });
                            });
                        })
                        .then(()=>{
                            p_porps.o_this.load(true, 1); // 追加分を表示
                            //
                            global.c?.setState({
                                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                                    _next.pckFiles.b_showMdl = false;
                                }),
                            });
                            //
                            cf.myRN_ldr_hide(global.c); // ldr の非表示
                            //
                            if (global.c?.state.sgcd_pageCmns?.cm10_key != global.c?.state.sgcd_pageCmns?.cm10_key) { // お客さまが送信者でない場合
                                cf.myCB_call_slc({
                                  ctr: 'nlm',
                                  elm: 'am1d', 
                                  n_dms: 2, 
                                  cnd: bf.q('[_KEY]={}'.f(global.c?.state.sgcd_pageCmns?.cm10_key))
                                })
                                .then((_d_am1ds) => {
                                    cf.myCB_call_eml(_d_am1ds.am1d1030, '新規メッセージのお知らせ', '{}さんが、新規にメッセージを登録しました'.f(global.c?.state.sgc_user_pfx))
                                });
                            };
                        });

                    }}
                    stlCta={{
                        width: ic.gn_mdlW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    }}
                />
            </ce.Mdl>
        );
    };

    static PckSch(pd){
        return (
            <ce._fld
                key={-1}
                b_vsb={pd.b_vsb}
                b_edt={pd.b_edt}
                pfx={pd.pfx}
                ini={pd.ini}
                mdlType={'pckSch'}
                b_newLine={pd.b_newLine}
                onChg={pd.onChg}
                onDltPrs={pd.onDltPrs}
            />
        );
    };

    static PckSchMdl(pd) {
        return (
            <ce.Mdl
                key={-1}
                mdlType={'pckSch'}
            >
                <View 
                    key={-1}
                    style={ [{
                        height: ic.gn_mdlH * 0.6,
                    }] }
                >
                    <View 
                        key={-1}
                        style={ [{
                            width: ic.gn_mdlW - ic.gn_mgnNrm * 2,
                            
                            marginLeft: 'auto',
                            marginRight: 'auto',

                            flexDirection: 'row',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                        }] }
                    >
                        <Icon
                            key={-1}
                            name='search'
                            color={(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].bdyCcd : ic.gdd_ccdDefss.cmn.bdyCcd}
                            size={ic.gn_iconSizeSml}
                        />
                        <TextInput 
                            key={-2}
                            editable={true}
                            multiline={false}
                            placeholder={'検索文字を入力ください'}
                            style={{
                                width: ic.gn_w - ic.gn_mgnNrm - ic.gn_iconSizeSml - ic.gn_mgnNrm - ic.gn_mgnNrm - ic.gn_btnWNrm - ic.gn_mgnNrm,
                                color: ic.g_fontCcdNrm,
                                fontSize: ic.gn_fontSizeNrm,
                                borderWidth: ic.gn_bdrWNrw * 1.5,
                                borderColor: ic.g_bdrCcd,
                                borderRadius: ic.gn_bdrRdsNrm,
                                marginTop: ic.gn_mgnNrm,
                                marginBottom: ic.gn_mgnNrm,
                                marginLeft: ic.gn_mgnNrm,
                                marginRight: 0,
                                paddingTop: ic.gn_mgnNrm,
                                paddingBottom: ic.gn_mgnNrm,
                                paddingLeft: ic.gn_mgnNrm,
                                paddingRight: ic.gn_mgnNrm,
                                borderRadius: (pd.b_mln || pd.b_bdr != false) ? ic.gn_bdrRdsNrm : 0,
                                minHeight: (pd.b_mln) ? ic.gn_fontSizeNrm * 8 : ic.gn_fontSizeNrm * 3,
                            }}
                            onChangeText={(_schKey)=>{
                                if (pd.onPckSchMdlEnt) {
                                    pd.onPckSchMdlEnt(_schKey);
                                };
                            }}
                        />
                    </View>
                    <ce.List
                        key={-2}
                        b_vsb={true}                    
                        state={null}
                        ld_itemss={global.c?.state.sgcd_mdls.pckSch.ld_itemss}
                        pfx={''}
                        b_chb={false}
                        b_prs={true}
                        onPrs={(_d_items, _key) => {
                            global.c?.setState({
                                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next => {
                                    _next.pckSch.d_slcItems = _d_items;
                                    _next.pckSch.b_showMdl = false;
                                }),
                            });
                        }} 
                    />
                </View>
            </ce.Mdl>
        );
    };
    static PckSchs(pd){
        //
        let _r = [];
        //
        for (let [_key, _d_items] of  bf.e(global.c?.state[pd.state])) {
            //
            _r.push(
                <>
                    { (_d_items.b_dlt != true) ?
                        <ce.PckSch
                            key={_key}
                            b_vsb={true}
                            b_edt={pd.b_edt}
                            
                            pfx={''}
                            b_newLine={false}
                            ini={_d_items.pfx}
                            onChg={(_d_slcItems)=>{
                                if (_d_slcItems.key != '') {
                                    global.c?.setState({
                                        [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                            _next[_key] = _d_slcItems;
                                        }),
                                    });
                                };
                            }}
                            onDltPrs={()=>{
                                global.c?.setState({
                                    [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                        _next[_key].b_dlt = true;
                                    }),
                                });
                            }}
                        />
                    : null }
                </>
            );
        };
        //
        _r.push(
            <ce.PckSch
                key={-1}
                b_vsb={true}
                b_edt={pd.b_edt}
                pfx={''}
                b_newLine={true}
                ini={''}
                onChg={(_d_slcItems)=>{
                    if (_d_slcItems.key != '') {
                        global.c?.setState({
                            [pd.state]: bf.p(global.c?.state[pd.state], _next => {
                                let _newKey = bf.myCM_get_newKey(_next);
                                _next[_newKey] = _d_slcItems;
                            }),
                        });
                    };
                }}
            />
        );
        //
        return (
            <View
                key={pd.key}
            >
                { (pd.pfx) ?
                    <ce.Lbl
                        key={-2}                        
                        pfx={pd.pfx}
                    />
                : null }
                {_r}
            </View>
        );
    }

  static Root (pd) {

    let _r = [];

    if (pd.backImg) {
      _r.push(
        <ImageBackground
          key={-1}
          style={{
            height:ic.gn_h, 
            width: ic.gn_w,
            backgroundColor: ic.g_ccdWN,
          }}
          source={pd.backImg}
        >
          { pd.children }
        </ImageBackground>
      );
    }
    else {
      _r.push(
        <View
          key={-1}
          style={{
            height:ic.gn_h, 
            width: ic.gn_w,
            backgroundColor: ic.g_ccdWN,
          }}
        >
          { pd.children }
        </View>
      );
    };

    return (
      <View style={[{ // hdr/ bdy/ ftr を中央配置するために必要
        key: -1,
        height: ic.gn_h, 
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start', 
        alignItems: 'center',
        backgroundColor: ic.g_baseCcd,                
      }]}>
        {_r}
        <ce.PckSlcMdl
          key={-2}
        />
        <ce.PckMdl
          key={-3}
        />
        <ce.PckSchMdl
          key={-4}
          onPckSchMdlEnt={pd.onPckSchMdlEnt}
        />
        <ce.FileMdl
          key={-5}
        />
        <ce.MenuMdl
          key={-6}
        />
        <ce.Ldr
          key={-7}
          state="sgcb_showLdr"
        />
      </View>
    );
  }

  static RootDtl (pd) {

    const [_sb_schVsb, _setSchVsb] = useState(false);

    return (
      <ce.Root
        key={-1}
        backImg={pd.backImg}
        onPckSchMdlEnt={pd.onPckSchMdlEnt}
      >
        <ce.Bdy
          key={-1}
          stlCta={{
            top: ((global.t?.state.sgcn_bdyY) ? global.t?.state.sgcn_bdyY : ic.gn_bdyY) + ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
            height: ic.gn_h - (ic.gn_hdrH + ic.gn_ftrH) - ((pd.d_btms?.n_h) ? pd.d_btms?.n_h : 0) - ((pd.d_tops?.n_h) ? pd.d_tops?.n_h : 0),
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
            backgroundColor: (pd.backCcd) ? pd.backCcd : ic.gn_backCcd,
          }}
          n_bdyW={pd.n_bdyW}
          b_ste={pd.b_ste}
          b_ctr={pd.b_ctr}
          onScrTop={pd.onBdyScrTop}
          onScrBtm={pd.onBdyScrBtm}
        >
          { ce._elms(pd.d_bdys?.ld_defss) }
        </ce.Bdy>
            
        <ce.Top
          key={-2}
          n_h={pd.d_tops?.n_h}
          n_pntW={pd.n_pntW}
          ld_defss={pd.d_tops?.ld_defss}
        />

        <ce.Btm
          key={-3}
          n_h={pd.d_btms?.n_h}
          n_pntW={pd.n_pntW}
          ld_defss={pd.d_btms?.ld_defss}
        />

        <ce.Hdr 
          key={-4}
          pfx={pd.d_hdrs?.pfx}
          b_logo={pd.b_logo}
          b_sch={(pd.onSchEnt) ? true : false}
          onSchPrs={()=>{
            _setSchVsb(true);
          }}
          b_leftVsb={pd.d_hdrs?.d_leftBtns?.b_vsb}
          leftIconName={
            (pd.d_hdrs?.d_leftBtns?.iconName) ? pd.d_hdrs?.d_leftBtns?.iconName :
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? 'remove' : 
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) ? 'arrow-left' : 
            null
          }
          leftPfx={
            (pd.d_hdrs?.d_leftBtns?.pfx) ? pd.d_hdrs?.d_leftBtns?.pfx :
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? 'キャンセル' : 
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) ? '戻る' : 
            null
          }
          onLeftPrs={()=>{
            if (pd.d_hdrs?.d_leftBtns?.onPrs) {
              pd.d_hdrs?.d_leftBtns?.onPrs();
            }
            else {
              if (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new'])) {
//                cf.myRN_move_bwd();
//                let _d = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]);
                let _d = iv.gdd_ftrDefss[global.c?.state.sgc_pageRole][global.c?.state.sgc_pageName].d_leftBtns.d_pageInfs;
                cf.myRN_move_fwd(_d);
              }
              else if (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['edit'])) {
//                cf.myRN_set_pageMode('show');
                cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                  _next[global.c?.state.sgc_pageName] = 'show';
                }))
                .then(() => {
                  global.c?.load(); // キャンセル時のリロード
                });
              }
              else if (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) {
                if (pd.d_hdrs?.d_leftBtns?.d_pageInfs) {
                  cf.myRN_move_fwd(pd.d_hdrs?.d_leftBtns?.d_pageInfs);
                }
                else {
//                  cf.myRN_move_bwd();
//                  let _d = iv._get_leftBtns(global.c?.state.sgc_pageRole, global.c?.state.sgc_pageName, global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]);
                  let _d = iv.gdd_ftrDefss[global.c?.state.sgc_pageRole][global.c?.state.sgc_pageName].d_leftBtns.d_pageInfs;
                  cf.myRN_move_fwd(_d);
                };
              };
            };
          }}
          stlLeftBtn={pd.stlLeftBtn}
          stlLeftPfx={pd.stlLeftPfx}
          b_rhtVsb={pd.b_rhtVsb}
          rhtIconName={
            (pd.rhtIconName) ? pd.rhtIconName :
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) ? 'pencil' : 
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? 'check' :
            null
          }
          rhtPfx={
            (pd.rhtPfx) ? pd.rhtPfx : 
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) ? '変更' : 
            (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? '登録・反映' :
            null
          }
          onRhtPrs={()=>{
            if (pd.onRhtPrs) {
              pd.onRhtPrs();
            }
            else {
              if (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new'])) {
                global.c?.ins();
              }
              else if (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['edit'])) {
                global.c?.upd();
              }
              else if (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) {
/*
                cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                  _next[global.c?.state.sgc_pageName] = 'edit';
                }))
*/
                cf.myLS_setStt('sgcd_pageModes', bf.p(global.c?.state.sgcd_pageModes, _next => {
                  _next[global.c?.state.sgc_pageName] = 'edit';
                }))
                .then(() => {
                  if (pd.onEditPrs) pd.onEditPrs();
                });
              };
            };
          }}
          stlRhtBtn={{
            backgroundColor: 
              (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) ? 
                ic.g_backCcd
              :
                (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
            borderColor:
              (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) ?
                ic.g_backCcd
              :
                (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
          }}
          stlRhtPfx={{
            color: 
              (bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['show'])) ?
                (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd
              :
                ic.g_backCcd, 
          }}
          b_subVsb={pd.d_hdrs?.d_subMenus?.b_vsb}
          subIconName={ (pd.d_hdrs?.d_subMenus?.iconName) ? pd.d_hdrs?.d_subMenus?.iconName : 'ellipsis-h' }
          subPfx={ (pd.d_hdrs?.d_subMenus?.pfx) ? pd.d_hdrs?.d_subMenus?.pfx : 'サブメニュー' } 
          onSubPrs={() => {
/*
            if (pd.d_hdrs?.d_subMenus?.onPrs) {
              pd.d_hdrs?.d_subMenus?.onPrs();

            };
*/
//alert('5223:{}'.f(pd.d_hdrs?.d_subMenus?.ld_iss))
//alert('5601:hello')
            if (bf.f(pd.d_hdrs?.d_subMenus?.ld_iss)) {
//alert('5225:here')
              global.c?.setState({
                sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                  _next.menu.ld_iss = pd.d_hdrs?.d_subMenus?.ld_iss;
                  _next.menu.b_showMdl = true;
                }),
              }, () => {
//alert('5232:here')
              });
            };
          }}
        />
          
        <ce.HdrSch
          key={-5}
          b_vsb={_sb_schVsb}
          onEnt={pd.onSchEnt}
          onCls={ () => {
            global.c?.setState({
              sgcd_schs: bf.p(global.c?.state.sgcd_schs, _next => {
                _next.word = '';
              }),
            }, () => {
              _setSchVsb(false);
            });
          }}
        />

        <ce.Ftr
          key={-6}
          dd_defss={iv.gdd_ftrDefss}
        />

      </ce.Root>
    );
  };

    static Row (pd) { // row
        return (
            <View
                style={[{
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }, pd.stlCta]}>
                { pd.children }
            </View>
        );
    }

    static Sch (pd) {
        return (
            <View 
                style={ [{
                    width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_mgnNrm * 2,
                    marginTop: ic.gn_mgnLrg,
                    marginBottom: ic.gn_mgnLrg,
                    marginLeft: 'auto',
                    marginRight: 'auto',

                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignSelf: 'center',
                    borderWidth: ic.gn_bdrWNrw * 1.5,
                    borderColor: ic.g_ccdHP,
                    borderRadius: ic.gn_bdrRdsNrm,
                }, pd.stlCta] }
            >
                <ce.Icon
                    stlCta={{
                        height: ic.gn_iconSizeSml,
                        width: ic.gn_iconSizeSml,
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        marginLeft: ic.gn_mgnNrm,
                    }}
                    name='search'
                    n_size={ic.gn_iconSizeSml}
                    ccd={(ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd}
                    margin={ic.gn_mgnNrm}
                />
                <ce.Inp
                    stlCta={[{
                        width: ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW) - ic.gn_scbW - ic.gn_iconSizeSml - ic.gn_mgnNrm * 5 - ic.gn_bdrWNrm * 2,
                        marginLeft: 'auto',
                        marginRight: 'auto',

                    }, pd.stlInpCta]}
                    stlInp={[{
                        borderColor: ic.g_ccdWN,
                    }, pd.stlInpInp]}
                    
                    
                    state={pd.state}
                    b_edt={true}
                    phd={pd.phd}
                    onChg={(_sch)=>{                        
                        global.c?.setState({[pd.state]:_sch});
                        if (pd.onChg){
                            pd.onChg(_sch);
                        };
                    }}
                    onLay={pd.onLay}
                />
            </View>
        );
    }

    static Spr (pd) { // separator
        return (
            <View
                style={[{
                    height: 0,
                    width: ic.gn_bdyW - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    borderWidth: 0,
                    borderBottomWidth: ic.gn_bdrWNrw,
                    borderColor: ic.g_ccdWN,
                    borderBottomColor: ic.g_ccdHP,
                    marginTop: ic.gn_mgnLrg,
                    marginBottom: ic.gn_mgnLrg,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }, pd.stlCta]}>
            </View>
        );
    }

    static Sti (pd) { // step indicator
        return (
            <View
                style={[{
                    width: ic.gn_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'center', 
                    alignItems: 'stretch',
                    margin: ic.gn_mgnNrm * 2,
                }]}
            >
                <StepIndicator
                    customStyles = {{
                        stepIndicatorSize: ic.gn_fontSizeSml * 2,
                        currentStepIndicatorSize:ic.gn_fontSizeSml * 2.6,
                        separatorStrokeWidth: 2,
                        currentStepStrokeWidth: 3,
                        stepStrokeCurrentColor: ic.g_ccdON,
                        stepStrokeWidth: 3,
                        stepStrokeFinishedColor: ic.g_ccdON,
                        stepStrokeUnFinishedColor: ic.g_ccdHN,
                        separatorFinishedColor: ic.g_ccdON,
                        separatorUnFinishedColor: ic.g_ccdHN,
                        stepIndicatorFinishedColor: ic.g_ccdON,
                        stepIndicatorUnFinishedColor: ic.g_ccdWN,
                        stepIndicatorCurrentColor: ic.g_ccdWN,
                        stepIndicatorLabelFontSize: ic.gn_fontSizeSml,
                        currentStepIndicatorLabelFontSize: ic.gn_fontSizeSml,
                        stepIndicatorLabelCurrentColor: ic.g_ccdON,
                        stepIndicatorLabelFinishedColor: ic.g_ccdWN,
                        stepIndicatorLabelUnFinishedColor: ic.g_ccdHN,
                        labelColor: ic.g_ccdHN,
                        labelSize: ic.gn_fontSizeSml,
                        currentStepLabelColor: ic.g_ccdON
                    }}
                    labels={pd.l_pfx}
                    stepCount={pd.l_pfx.length}
                    currentPosition={pd.n_step}
                />
            </View>
        );
    }

    static Tck(pd){
        //
        const [_s_val, _setVal] = useState(0);
        //
        useEffect(() => {
            let _n_cnt = 0;
            let _id = setInterval(() => {
                _n_cnt += 1;
                if (_n_cnt >= pd.n_cnt) {
                    _setVal(pd.n_val);
                    clearInterval(_id);
                }
                else {
                    _setVal(bf.myCM_get_rnd(999));
                };
            }, 250);
        }, [pd.n_val]);
        //
        return (
            <>
                {(pd.b_vsb) ?
                    <View
                        style={[{
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }, pd.stlCta]}
                    >
                        <Ticker
                            textStyle={[{
                                fontSize: ic.gn_fontSizeNrm,
                                fontWeight: 'bold',
                                color: ic.g_ccdWN,
                            }, pd.stlPfx]}
                            duration={250}
                        >
                            {'{}'.f(bf.myCM_pdd(_s_val, 3))}
                        </Ticker>
                    </View>
                : null }
            </>
        );
    }

/*
    static Top (pd) {
        return (
            <>
                { (pd.b_vsb) ?
                    <View
                      style={{
                        position: 'absolute',
                        zIndex: ic.gn_zIdxBdy,
                        top: ic.gn_hdrH,
                        left: 0,
                        height: pd.n_h,
                        width: ic.gn_w,
                        backgroundColor: (ic.gdd_ccdDefss[global.c?.state.sgc_pageRole]) ? ic.gdd_ccdDefss[global.c?.state.sgc_pageRole].hdrCcd : ic.gdd_ccdDefss.cmn.hdrCcd,
                      }}
                    >                
                      { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
                    </View>
                : null }
            </>
        );
    };
*/

  static Top (pd) {
//bf.l('6469:{}'.f(pd))
    return (
      <View
        style={{
          position: 'absolute',
          zIndex: ic.gn_zIdxBdy,
//          top: ((global.c?.state.sgcn_bdyY) ? global.c?.state.sgcn_bdyY : ic.gn_bdyY) + ic.gn_h - (ic.gn_hdrH + ((pd.n_h) ? pd.n_h : 0) + ic.gn_ftrH),
          top: ic.gn_hdrH,
          left: (ic.gn_w - ((pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW)) / 2,
          height: (pd.n_h) ? pd.n_h : 0,
          width: (pd.n_pntW) ? pd.n_pntW : ic.gn_bdyW,
          justifyContent: 'center',
        }}
      >                
        { (pd.ld_defss) ? ce._elms(pd.ld_defss) : null }
      </View>
    );
  };

    static Tree(pd){
        //
        let _r1 = [];
        let _r2 = [];
        //
        let _ld_itemss = global.c?.state[pd.state];
        //
        let _topH = ic.gn_fontSizeNrm + ic.gn_mgnLrg * 2;
        //
        let _w = (ic.gn_w - ic.gn_mgnNrm * 2) / 27;
        let _h = (ic.gn_bdyH - _topH - ic.gn_mgnNrm * 2) / 3 - ic.gn_bdrWNrw * 2;
        //
        function _fnc01(pn_x, pn_y, pn_w, pn_h, p_pfx, p_key) {
            return (
                <View
                    style={{
                        height: pn_w,
                        width: pn_h,
                        transform: [{ rotate: '90deg'}],
                        position: 'absolute',
                        zIndex: 10,
                        top: pn_y - pn_w/2,
                        left: pn_x - pn_h/2,
                        backgroundColor: (p_key != 0) ? ic.g_ccdWN : '#eeeeee',
                        borderColor: (p_key != 0) ? ic.g_ccdHN : ic.g_ccdWN,                        
                        borderWidth: ic.gn_bdrWNrw,
                        borderRadius: ic.gn_bdrRdsNrm,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <TouchableOpacity
                        onPress={()=>{
                            if (pd.onPrs && p_key != 0) {
                                pd.onPrs(p_key);
                            };
                        }}
                    >
                        <Text
                            style={{
                                lineHeight: pn_w, 
                                height: pn_w,
                                width: pn_h,
                                color: ic.g_fontCcdNrm,
                                fontSize: (ic.gn_fontSizeNrm > pn_w * 0.8) ? pn_w * 0.8 : ic.gn_fontSizeNrm,
                                marginStart: 0, 
                                marginEnd: 0, 
                                marginTop: 0, 
                                marginBottom: 0, 
                                paddingStart: ic.gn_mgnNrm, 
                                paddingEnd: 0, 
                                paddingTop: 0, 
                                paddingBottom: 0, 
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {p_pfx}
                        </Text>
                    </TouchableOpacity>
                </View>
            );
        };
        //
        // １階層目
        let _cnt1 = 0;
        bf.myCM_for_each(_ld_itemss, (_d_items1)=>{
            if (_d_items1.pntKey == '') {
                _cnt1 += 1;
                let _x = (ic.gn_w - ic.gn_mgnNrm * 2) / 2 / 1 + (ic.gn_w - ic.gn_mgnNrm * 2) / 1 * (_cnt1 -1) - _w / 2 + ic.gn_mgnNrm;
                let _y = ic.gn_hdrH + _h * (1 - 1) + ic.gn_mgnNrm + _topH;
                _r1.push(
                    <>
                        <ce.Row
                            stlCta={{
                                width: ic.gn_w - ic.gn_mgnNrm * 2 - ic.gn_scbW,
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            { (pd.b_leftPrs) ?
                                <ce.Btn
                                    
                                    stlCta={{
                                        width: ic.gn_btnWSml,
                                    }}
                                    stlBtn={{
                                        width: ic.gn_btnWSml,
                                    }}
                                    pfx='＜'
                                    onPrs={pd.onLeftPrs}
                                />
                            :
                                <View
                                    style={{
                                        width: ic.gn_btnWSml,
                                    }}
                                >
                                </View>
                            }
                            <View
                                style={{
                                    height: _topH,
                                    width: ic.gn_w - ic.gn_mgnNrm * 2 - ic.gn_btnWSml * 2,
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                            >
                                <Text
                                >
                                    {_d_items1.pfx}
                                </Text>
                            </View>
                            { (pd.b_RhtPrs) ?
                            <ce.Btn
                                
                                stlCta={{
                                    width: ic.gn_btnWSml,
                                }}
                                stlBtn={{
                                    width: ic.gn_btnWSml,
                                }}
                                pfx='＞'
                                onPrs={pd.onRhtPrs}
                            />
                            :
                                <View
                                    style={{
                                        width: ic.gn_btnWSml,
                                    }}
                                >
                                </View>
                            }
                        </ce.Row>
                    </>
                );
                //
                // ダミー
                //
                // ２階層目
                for (let _cnt2 of [1,2,3]) {
                    let _x = (ic.gn_w - ic.gn_mgnNrm * 2) / 2 / 3 + (ic.gn_w - ic.gn_mgnNrm * 2) / 3 * (_cnt2 -1) - _w / 2 + ic.gn_mgnNrm ;
                    let _y = ic.gn_hdrH + _topH + _h * (2 - 2) + ic.gn_mgnNrm;
                    _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                    //
                    // ３階層目
                    for (let _cnt3 of [1,2,3]) {
                        let _x = (ic.gn_w - ic.gn_mgnNrm * 2) / 2 / 9 + (ic.gn_w - ic.gn_mgnNrm * 2) / 9 * (_cnt3  + (_cnt2 - 1) * 3 - 1) - _w / 2 + ic.gn_mgnNrm ;
                        let _y = ic.gn_hdrH + _h * (3 - 2) + ic.gn_mgnNrm + _topH;
                        _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                        //
                        // ４階層目
                        for (let _cnt4 of [1,2,3]) {
                            let _x = (ic.gn_w - ic.gn_mgnNrm * 2) / 2 / 27 + (ic.gn_w - ic.gn_mgnNrm * 2) / 27 * (_cnt4 + (_cnt3 - 1) * 3  + (_cnt2 - 1) * 9 - 1) - _w / 2 + ic.gn_mgnNrm ;
                            let _y = ic.gn_hdrH + _h * (4 - 2) + ic.gn_mgnNrm + _topH;
                            _r2.push(_fnc01(_x, _y, _w, _h, '', 0));
                        };
                    };
                };
                //
                // 実データ
                //
                // ２階層目
                let _cnt2 = 0;
                bf.myCM_for_each(_ld_itemss, (_d_items2)=>{
                    if (_d_items2.pntKey == _d_items1.key) {
                        _cnt2 += 1;
                        let _x = (ic.gn_w - ic.gn_mgnNrm * 2) / 2 / 3 + (ic.gn_w - ic.gn_mgnNrm * 2) / 3 * (_cnt2 -1) - _w / 2 + ic.gn_mgnNrm ;
                        let _y = ic.gn_hdrH + _topH + _h * (2 - 2) + ic.gn_mgnNrm;
                        _r2.push(_fnc01(_x, _y, _w, _h, _d_items2.pfx, _d_items2.key));
                        //
                        // ３階層目
                        let _cnt3 = 0;
                        bf.myCM_for_each(_ld_itemss, async (_d_items3)=>{
                            if (_d_items3.pntKey == _d_items2.key) {
                                _cnt3 += 1;
                                let _x = (ic.gn_w - ic.gn_mgnNrm * 2) / 2 / 9 + (ic.gn_w - ic.gn_mgnNrm * 2) / 9 * (_cnt3  + (_cnt2 - 1) * 3 - 1) - _w / 2 + ic.gn_mgnNrm ;
                                let _y = ic.gn_hdrH + _h * (3 - 2) + ic.gn_mgnNrm + _topH;
                                _r2.push(_fnc01(_x, _y, _w, _h, _d_items3.pfx, _d_items3.key));
                                //
                                // ４階層目
                                let _cnt4 = 0;
                                await bf.myCM_for_each(_ld_itemss, (_d_items4)=>{
                                    if (_d_items4.pntKey == _d_items3.key) {
                                        _cnt4 += 1;
                                        let _x = (ic.gn_w - ic.gn_mgnNrm * 2) / 2 / 27 + (ic.gn_w - ic.gn_mgnNrm * 2) / 27 * (_cnt4 + (_cnt3 - 1) * 3  + (_cnt2 - 1) * 9 - 1) - _w / 2 + ic.gn_mgnNrm ;
                                        let _y = ic.gn_hdrH + _h * (4 - 2) + ic.gn_mgnNrm + _topH;
                                        _r2.push(_fnc01(_x, _y, _w, _h, _d_items4.pfx, _d_items4.key));
                                    };
                                });
                            };
                        });
                    };
                });
            };
        });
        //
        return (
            <>
                <View>
                    {_r1}
                </View>
                <View
                    style={{
                    }}
                >
                    {_r2}
                </View>
            </>
        );
    }
}
